<template>
  <div class="all" ref="all">
    <div class="box">
      <div class="box-left">
        <img class="img" src="https://serenetone-platform.oss-cn-shanghai.aliyuncs.com/sonitalk-logo.png">
        <div class="img_div">
          <img class="box-left-right" :src="cmxt">
          <div class="box-left-right-bottom">慢生活尽在柴门小童~</div>
        </div>
      </div>
      <div>
        <open-tag :extinfo="getList.postId" style="display: flex;outline: none !important;background: none !important;">
          <!-- 微信环境的solt -->
          <template v-slot:weixin>
            <script type="text/wxtag-template">
              <style>
                .btn {
                  font-size: 12px;
                  text-align: center;
                  width: 80px !important;
                  height: 28px !important;
                  line-height: 28px !important;
                  background: url(data:image/png;base64,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) no-repeat;
                  background-size: 100% 100%;
                  font-weight: 400;
                  margin-right: 13px;
                  color: #FFFFFF;
                  outline: none !important;
                  -webkit-tap-highlight-color: transparent !important;
                  border: none !important;
                }
              </style>
              <!--              <img class="box-left-right" :src="btn_bg">-->
              <button class="btn">
                <!--                打开APP-->
              </button>
            </script>
          </template>
          <!-- 非微信环境的slot -->

          <template v-slot:unWeixin>
            <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="browser-open-app" type="danger">
            </div>
            <span v-else class="browser-open-app" @click="unInstall"></span>
          </template>
        </open-tag>
      </div>
    </div>
    <!-- 轮播 -->
    <div v-if="images" class="vant-margin-wrap">

      <van-swipe ref="swipe" :loop="false" @change="onChange" class="van-swipe"
                 indicator-color="#071679FF" :show-indicators="false">
        <van-swipe-item class="images" v-for="(item, zindex) in images" :key="zindex">
          <van-image fit="contain" :src="item.url"
                     @click="openImg(item.url)"></van-image>
        </van-swipe-item>

        <template #indicator>
          <div class="dots" style="bottom:-15px;" v-if="images.length>12 ">
            <div class="dotWrapper" style="width:auto;">
              <div class="dotWrapper_div" v-for="(item, index) in images" :key="index"
                   :class="`dot
${index === swipeIndex - 1 && 'selectedDot'}`"></div>
            </div>
          </div>
          <div class="dots" style="bottom:-15px;" v-if="images.length>10 && images.length<=12">
            <div class="dotWrapper" style="width:auto;">
              <div class="dotWrapper_div1" v-for="(item, index) in images" :key="index"
                   :class="`dot
${index === swipeIndex - 1 && 'selectedDot'}`"></div>
            </div>
          </div>
          <!--          <div class="dots"  v-if="images.length >10">-->
          <!--            <div class="navItem" style="width:30px;height:2px;border-radius: 6px;"-->
          <!--                 :style="{ animation: moveLeft && index == 0 ? 'moveLeftOne 0.2s linear' : moveLeft && index == 1 ? 'moveLeftTiny 0.2s linear' : moveLeft && index > 1 ? 'moveLeft 0.2s linear' : moveRight && index == 3 ? 'moveRightTiny 0.2s linear' : moveRight && index < 3 ? 'moveRight 0.2s linear' : moveRight && index == 4 ? 'moveRightOne 0.2s linear' : '' }"-->
          <!--                 :class="current == (index + 1) ? 'active': index == 0 && first ? 'mini' : index == 4 && last ? 'mini' : ''"-->
          <!--                 v-for="(item, index) in images.length" :key="index">-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="dots" style="bottom:-15px;" v-if="images.length<=10 && images.length>1">
            <div class="dotWrapper" style="width:auto;">
              <div class="dotWrapper_div2" v-for="(item, index) in images" :key="index"
                   :class="`dot
${index === swipeIndex - 1 && 'selectedDot'}`"></div>
            </div>
          </div>
        </template>

      </van-swipe>
      <!--      分享-->
      <!--      <img class="swipe-num" src="../assets/black_share.png" alt=""/>-->
      <!--            <div class="swipe-num">{{ swipeIndex }}/{{ images.length }}-->
      <!--            </div>-->
    </div>
    <!--    是否展示展示自我发布入口  inviteIf-->
    <div class="zszw" v-if="false">
      <div class="zszw-content">
        <div class="zszw-content-left">
          <img src="../assets/showme.svg" alt="">
          <span>展示自我</span>
        </div>
        <img style="margin-right: 10px" src="../assets/right-2.svg">
      </div>
    </div>
    <!--  用户信息  -->
    <div class="post">
      <div class="tops">
        <div class="head">
          <div class="head-img" >
            <canvas class="myCanvas" id="myCanvas"></canvas>
          </div>
          <!-- <van-image class=" head-img" :src="creator.avatar" :round="true" fit="cover"></van-image> -->
          <div class="head-lable">
            <span class="befautiful">【发现美】</span>
            <div class="title_box" style="width: 197px;">
              <span class="nickName">{{ creator.nickname }}</span>
              <span class="label" v-for="(item, index) in creatorLabels" :key="index">
                {{ item }}
              </span>
              <!-- 试试 -->
            </div>
          </div>
        </div>
        <!--        <div class="guanzhu">关注</div>-->
        <open-tag :extinfo="getList.postId" style="display: flex;position: absolute;right:3px;">
          <!-- 微信环境的solt -->

          <template v-slot:weixin>
            <script type="text/wxtag-template">
              <style>
                .btn {
                  width: 62px;
                  height: 28px;
                  font-size: 14px;
                  color: #384594;
                  /*font-weight: 700;*/
                  background: url(data:image/png;base64,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) no-repeat;
                  /*background: none !important;*/
                  outline: none !important;
                  -webkit-tap-highlight-color: transparent !important;
                  border: 1px solid transparent;
                  background-size: 100% 100%;
                  margin-right: 12px;
                  font-weight: 500;
                  display: block;
                  line-height: 26px;
                  text-align: center;
                  margin-top: 10px;
                }
              </style>
              <button class="btn">

              </button>
              <!--              <img class="btn" src="../assets/guanzhu-bg.svg" alt="">-->
            </script>
          </template>
          <!-- 非微信环境的slot -->

          <template v-slot:unWeixin>
            <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="guanzhu" type="danger">关注</div>
            <span v-else class="guanzhu" @click="unInstall">关注</span>
          </template>
        </open-tag>
        <!--        <img style="position: absolute;right:10px;margin-top:2px;z-index:-1;" src="../assets/black_share.svg" alt=""/>-->
      </div>
    </div>
    <div v-if="title" class="tit">{{ title }}</div>
    <!--  地址和时间  -->
    <!-- <div class="placetime" v-if="inviteIf">
      <div class="places">
        <img style=" vertical-align: middle" src="../assets/location.svg">
        <span style="vertical-align: middle; margin-left: 2px">{{ inviteInfo.fromCity }}—{{ inviteInfo.toCity }}
        </span>
      </div>
      <div class="time">
        <img style="vertical-align: middle;" src="../assets/time.svg" />
        <span style=" white-space: nowrap;vertical-align: middle; margin-left: 3px">{{ inviteInfo.inviteBeginEndDate }}
        </span>
      </div>
    </div> -->
    <!-- 邀约遮罩 -->
    <div v-if="inviteIf" style="position: absolute; width:100%;z-index:2;background: none;" class="invite">
      <open-tag :extinfo="getList.postId">
        <!-- 微信环境的solt -->

        <template v-slot:weixin>
          <script type="text/wxtag-template">
            <style>
              .s {
                width: 500px;
                height: 100px;
                font-size: 13px;
                color: #FFFFFF;
                line-height: 35px;
                text-align: center;
                z-index: 222;
              }
            </style>
            <div class="s">
            </div>
          </script>

        </template>
        <!-- 非微信环境的slot -->

        <template v-slot:unWeixin>
          <div v-if="!isAndroid() || isWeibo()" @click="showModal"
               style="position: absolute;left:0;width:100%;height:100%;" type="danger"></div>
          <span v-else style="display: block;position: absolute;left:0;width:100%;height:100%;"
                @click="unInstall"></span>
        </template>
      </open-tag>
    </div>
    <!--  邀约  -->
    <div v-if="inviteIf" class="invite">
      <div class="invite-top">
        <div>
          <div class="places">
            <span style="vertical-align: middle; margin-left: 2px">{{ inviteLocation }}
            </span>
          </div>
          <div class="time">
            <span style=" white-space: nowrap;vertical-align: middle; margin-left: 3px">{{
                inviteInfo.inviteBeginEndDate
              }}
            </span>
          </div>
        </div>
        <!-- <div class="top1">
          <div>人数</div>
          <span>{{ inviteInfo.joinedMembers }}/{{ inviteInfo.members }}人</span>
        </div>
        <div class="top1">
          <div>出行方式</div>
          <span>{{ inviteInfo.transportMode }}</span>
        </div>
        <div class="top1">
          <div>付费方式</div>
          <span>{{ inviteInfo.payMode }}</span>
        </div> -->
      </div>
      <!-- 立即参与 -->
      <div class="invite-bottom">
        <div class="imgview">
          <van-image v-if="sum > 0 && sum <= 5" v-for="item in avatarslist" :key="item.user.userId" class="tou"
                     :src="item.user.avatar"/>
          <van-image v-if="sum > 5" v-for="item in avatarslist.slice(0, 5)" :key="item.user.userId" class="tou"
                     fit="cover" :src="item.user.avatar"/>
          <!-- <img v-if="sum > 5" v-for="item in avatarslist.slice(0, 5)" :key="item.user.userId" class="tou" fit="cover"
            :src="item.user.avatar" /> -->
          <span v-if="sum <= 0" style="color:#AAAAAA; font-size: 12px; text-align: center">暂无成员</span>
        </div>
        <img class="circle-img" v-if="sum > 5" src="@/assets/circle.svg" alt="">
        <!--    进度条 -->
        <div class="jindu">
          <div class="nv">
            <img style="width: 28.5px;height: 28.5px;margin-top: -12px" src="../assets/man.png">
            <img style="width: 28.5px;height: 28.5px;margin-top: -12px" src="../assets/woman.png">
          </div>
          <!--          <div class="player">-->
          <!--            <div class="progress-bar" :style="{ background: '#F6AAAE', width: '100%' }">-->
          <!--              <div class="progress" :style="{ background: '#6B7AFF', width: progress + '%' }"></div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="nv">
            <span style="background-color:#5088DE ;" class="bfb">{{ percentage(man) }}</span>
            <span style="background-color:#FE5254 ;" class="bfb">{{ percentage(woman) }}</span>
          </div>
        </div>
        <div class="canyu">
          <!-- <div>立即加入</div>inviteInfo.joinedMembers inviteInfo.members -->
          <div class="party" v-if="sum > 0 && inviteInfo.joinedMembers !== inviteInfo.members">
            <!--            <img class="people" src="../assets/people.png"/>-->
            <!--            <span>聚一聚</span>-->
          </div>
          <div class="full" v-if="sum > 0 && inviteInfo.joinedMembers == inviteInfo.members">
            <!--            队伍已满-->
          </div>
          <!-- <label-text></label-text> -->
          <!-- <img style="color:rgba(77, 198, 201, 1);" src="../assets/right1.svg" /> -->
        </div>
      </div>


    </div>
    <div style="position: absolute; width:100%;z-index:2;height:274px;" class="all-in" v-if="allPayedIf.length">
      <open-tag :extinfo="getList.postId">
        <!-- 微信环境的solt -->
        <template v-slot:weixin>
          <script type="text/wxtag-template">
            <style>
              .s {
                width: 140px;
                height: 274px;
                font-size: 13px;
                color: #FFFFFF;
                line-height: 35px;
                text-align: center;
                z-index: 222;
              }
            </style>
            <div class="s">
            </div>
          </script>
        </template>
        <!-- 非微信环境的slot -->

        <template v-slot:unWeixin>
          <div v-if="!isAndroid() || isWeibo()" @click="showModal"
               style="position: absolute;left:0;width:100%;height:100%;" type="danger"></div>
          <span v-else style="display: block;position: absolute;left:0;width:100%;height:100%;"
                @click="unInstall"></span>
        </template>
      </open-tag>
    </div>

    <!--    费用全包  v-if="allPayedIf.length" -->
    <div class="all-in" v-if="allPayedIf.length">
      <img src="../assets/Group.svg">
      <img style="margin-top: 11px" src="../assets/flower.svg">
      <div class="all-in-rqz">慢生活</div>
      <div class="all-in-avater">
        <!-- <van-image class="all-in-avater-img imgOne" :src="allPayedIf[0].avatarShow" fit="cover"/> -->
        <img class="all-in-avater-img imgOne" :src="allPayedIf[0].avatarShow" fit="cover"/>
        <img class="all-in-avater-img imgTwo" style="z-index: 100;  " src="../assets/hpbg.png">
      </div>
      <img v-if="false" style="margin-top: 7px;margin-bottom:14px;" src="../assets/nz.svg">
      <div class="nicknameShow">{{ allPayedIf[0].nicknameShow }}</div>
      <img src="../assets/fast.svg" alt="">
      <!--      <div class="all-in-first">费用全包</div>-->
      <!--      <div class="all-in-last">-->
      <!--        <div class="all-in-head">-->
      <!--          <van-image class="all-in-head-img" :src="allPayedIf[0].user.avatar" :round="true" fit="cover"></van-image>-->
      <!--          <span style="margin-left: 2px;font-size: 11px; color: rgba(102, 102, 102, 1)"-->
      <!--                class="nicknames">{{ allPayedIf[0].user.nickname }}</span>-->
      <!--        </div>-->
      <!--        <div style="display: flex;align-items: center; margin-left: 10px; margin-top: 2px">-->
      <!--          <div class="heat">-->
      <!--            <img src="./../assets/ic_popularity.svg">-->
      <!--            <span>人气值 {{ allPayedIf[0].meiliShow }}</span>-->
      <!--          </div>-->
      <!--          <div style="display: flex; justify-content: space-between; align-items: center; margin-left: 7px">-->
      <!--            <div class="all-in-label" v-for="(item,index) in allPayedIf[0].user.labels" :key="index">{{ item }}</div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <img class="right-jt" src="./../assets/home_more.svg">-->
    </div>

    <div style=" position: fixed; bottom: 2.3rem;left: 50%;transform: translate(-50%, -50%); z-index: 2">
      <open-tag :extinfo="getList.postId">
        <!-- 微信环境的solt -->

        <template v-slot:weixin>
          <script type="text/wxtag-template">

            <style>
              .s {
                width: 133px;
                height: 40px;
                /*background: url(../assets/nav_bg.svg) no-repeat;*/
                background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUQAAABaCAYAAADAQS+ZAAAAAXNSR0IArs4c6QAAIABJREFUeF7tfXmcXUWV/7mvQyAIIWyyC0QEBpGEX0KSZl+TdBKMMiBRdByRRUwnQFD8ARlBBVdG+LmCHx2UEVCHRUhI0ukOAQXSSUAiBpTFgCBrICH72n3nV7du1Vnq1Hv3ve7OAq//gLx7b1WdW7fqW9+z1KkE6n/1Hqj3QL0H6j2Q9UCyqfqhsfHRPtB3+QmdSXJ8ksDAFKB/ArBXCrA9APQygqRCGHqtfn9r6R/8ivjN0myg8e9rr5k/c93eT+kPSLIHUkhTyP5t/k8f4OWz0uRPq9+Vt49h+e6UD98lk5+9kpXQ9YVt38qt9VXs/Vxfhf1n6+P12xaya3kH2b5M8/611zVZ5DUnbQKJrxO/iK2cfkspH5bH53AEZIU3pgmsAoDXE4BFkKZPJKXkj7B8+UNz5kxasymwqscBcXDTtCMb0l4XJkn6qRRgx03xUvU2NmcPyGWNgxCbAAy/8lnpitMZnD/nQZMBiKuEg5qdsvwvVt49GwNwCkBcPCuzE5WCdriYS/kQqIJFoWbQdPCqgG6+qFiAtmCIQKjLQpcwB3QUwPnygwuQ9o1p+XB04qJgUZWMBYtQK9NOuD1t6PjJvJYv/LknR3ePAeKQETMGlEql/5dCegJ9AY3p1e9jD2y9/cPZTwz4KChxSpGXZ0xQDn2cyHiHw15Qv39Qky8E67LlKVNNcuonQTdnX+Xl0xYJey38/jqQhnMmZJ+GBZo/BGr37/jigUCJC0qMvTpOWAT8NSCl5T0OkoUQQdT2Tf77oQ6AS+a3XrCgJ4Cx2wHxmI8+vOPG9Su/lSTJF1KABif01jvR7RvU5Q9VdjrpnRpVDghwWDPdygJBPhI9vDn9Lq8Q1U/J+xAIEGbCZ4x8yJ+clFy9d+UDdpmpl1jezlkOzl5+c12aARTblFdj81XByUclk4yW9m2oZvMRGpPP6c3MTJGDJqXUXD5UqauVz33z8P2IScOxV7J4OTMJZbR+AQXYmAL8GJav/ercuROXdycwdisgNo6YcVBnqXQvQHpYdwpZr2tL7wEdpEKpy6jTbIYXUbtDULNXOMihZUtKE7IxCZnq76zCkHlp7E6vj5T3NYXs1YCygSEKTBpA4lOhHRIBPtdCE2uPdQs87a8QYMP+ovXFFj4nLy+N36S86pwvNK4wYYtqfQn8LUkaTp/Tct7z3TVDug0QhzS1nFyC9M4Ukp1jbIqvnOEr1O8zn0LQQVtm/0gAMkAjORaZ8NJBQgYLNfZzgqiog4GFkDgzGCyGAKmrxSg3VRE9xnpboWWLTh2loOLVTaI2F1EnnXIaY5buDZzcvE6h2uZslqvLORtzdkNilqBtIpvDZYW2yQDWLQqEDevluX0wYKbOZGhMEP7fzoyIy5kDKmv/tP2fX3sb0s4z29suerA7QLFbAHHIyLbGJOloBYD3dYdQ9Tq2ph7Q7V70DWIA5MCGe5A1JqcDLCMSCkA6sAoXaM5Adfmcs4SqxgzN0TGhAqBUnS1cdBdAMoAgC0AAYF5kuahwsHG/JCBYxof9b++HjI+COv2CkuHSBYQDIIJ2oLp7BxDnsQSg13QkyanzZ17waFdnTpcBcWhT22GQdvwREtilq8LUy29tPRCqyiE75BPIa0HOKcHQSjpNwgkQAy+vxiqhH1RKybJkfZKlqb8JLsbqk2xeerL1ciHLlQAnWRpneArLciE2ZPWwTlwe7kOBjrI4afuTLBABpAq1OF8YcLTnZenn9gOFw6s+Q7J3eTvtLB09b9YFz3ZlFnUJEE1sYWe/5QsAkoPDVZg7Iur3Q6dEyBb4p9yy79fm/cRANREHF3hn9dg4aSNEgCgShxgyQznB/ReQcXqUBRLV0xjlNPsb2sqcGUR6beNxkhzkSBxhLlzAAkUcJ1Xds9Kc2Hr3ErLMauMQeRwhtRtyMEU+6ADX36eOFBJmw8oHoBEH8byl5zdsVxrw+JQLV9cKil0CxKFNLTcAwCW1Nl4vt7X2gGSGnAUGKz+lNV5PknpejQCbNcbVQT18BVmRKYFzraBqK73KxGctWSStPwACD2oFbGveO10AdCMAHoIejzl030oDtVgcYjhqRRyhYr6wQBcfN9SrrMUzFHfWwPfbW79wWa0zq2ZAHNrUOgySjkcgTUq0cY0J1u9jD7w7+ic+sCnQBINSGPyRP5D+qRSHyCxYIRAXVam1thHIiAqXXcSYw8r2Tjmdi9krQ1BHqAo1hcjiwVT5SBwhcUhQuyF33FS/eNA1LxayQ1mzXRdxIfPliaqMz3N7Z+zb5by1o6Ozo3H+rPHzawHFmgFx2MiW6WkCI12j746JHu/C+vtJvkD7iqt/wYAl6pGfph4n8kmRdzC3RFFQ0KAOn6ZMKGQY1jHA4xArqM/SGZE3gNpdCEo0+Jiqfg5oscc0xsdHmA4quAAwNZ2wQ99jJB4ya99Xz8GliDPEMm4pXwia2vtZiZXyTma3tdF/QAl+kn260RWaHMh3n9XeetGpmwwQBze1HtkA6eMAac2AWouw9TJbQg9Idlil+kwfJ2yAv1mxNvRFioMkTi+uJiMbJOxUbPez4hWpz057KY+EYPqbq7ISIFG9pMCnl8d9ynLrIBWoEsDi0iO34HEWLlmbHJEVVdvcocM2svtKqhxLrHE2sNLOjXDkvNnVb/OrGtAsGHb+BACGyc7gtpRw8tbvb41xhpSlSfl1dTDwNOe0yuGfizfUx088jIePnxA0adIBjWk6QOnOOEkJUhoz5OpomW1zhE3J2EQKuNQs4fs0R3i7QwXjJPGdkbfHZEY2V0scon3zEHiFrZTIh4uCHiep2RwrAi46mP57busX/61aClEYEI3NMEk7r06TZESdGVbbze+G5+OsjU7Q4E2l3VBhhWXLR/b30nYkE5NsM2SSaLvyAMYzHfjthGGmHcooUR3kAKbUHzh+9EDy4gCWc18R6K4nbSgSR4gsl/ZfzB6IyyR/jxhj9N1Lvz8LFJfMVKr2ulNGU8cRztPWDoDL57eOL7zvuSIg5qE13wSAiQDcgfJumOb1dyjSA5oqw1Upxz9UNZaEVcTYoe5UCNulgCHZGFWD5XNSPsk22W/iUaYAI4OM3WTUr3M2XSQOUaqt9P3oRKUgzkJs8n6WyWIkq5LyIncMWaQGECFL498prlbnzwV2gCImEn286VkGmH7QCSn8fOPShksff7xyOE5ZQMyCrmHjPfU4Q73b6eTXgODdc19XY8P3IwPbO1K0fIZ24vF8gegVpeDlpoHGIqXKJacl3kcWI5mldIQYIqfmCxT7gOmkp/NbqrZdU0NdT5D+j8rHvbaZTDkbQ1l5TCPvH8nINKdFrLwWU6nbIinjdvkuaSCnXGTwe3H55HW5mEgtASBZmHZuPHvurIlPl6MAUUAcMnJ6Y5KUpgLUd6AU4VDv3mc0dljDtcgWMspOAtuY6FTN9lWkvMYWg7oUrzJNhKCpjlrsnrT92QmmeZVlcLMe6uLsaCqoUe+99Nrm7SJQhMHXFFRo/XocYJjxpqryRD67GuYbl/NK4qySLwoh0HFWq8nur6WwIgUYNbdt/MOx+aoCoknUkADcp+1NVlUiUnv9vv5JXBdtXf0TV1ljA5MxuaB4d+czLCqf45mhp5lvM4knbvDfT9lRQ4Eh/L5cRgrEfEwUsDsKdoiATWIOyb5f17K20MQWn9jiUSSkSIJa1r5PTJsvCr7hMJwmW2Bo8kYB6jFWWP56MEZWdnSko+c/0PwHDRQDQDQpvNISzDNZa2iBrWsih69al79aoA4nMnId2r84kRF2XNoSF0VN8gkqIOkIA5YPbUrVxBGGX19R6ZydkE5a7+WlSZvz98sHkJ30ReIIi8XpOUUwli+QgQoBCFQ9iXzkA3BGG4sjxMhMDgRF3k9Xqd0oq5DPMDyCgAClew3JrmOMVHes8NHE3i+FFUmpc8icmRP+JscKey5L7rphdXs9n2GMUL9XrhdViRkEou6S0YK8r9yMjnZdCH4aoGmMVC5ykn3pvzW2aAFckpOu1EdV3RgTxImvq9QUGDzA5d3lEtKGCV9tqfIAh59HLpPFwlq08eE+v+4tdkzcJZao/I3dE7WMD2Vc+gY9b164YUmvodLRwvpt6MgZP4IkGR9jU+56/b7Ott4d/cPTPRGUE5mgw0FnzUJxtVjLF0gnhqau0Z7G+9qJKfqe5KB+KZ8VOnustnyGRF0VmXayOkkS2DBOUt+CJ9NtZcHhFc5uySYyOTxKs39KgKXy4fqlx0ny+zyMh9lSxfZBK1MOwEI+2aZkhtoa2jUPtzgcK4WfzW1rvlCOkey3PQMleZym/X+v8KH6e8oeqGz3IoZqfiIeXS1zsIklVNWYk8YcwgW4mHzhAqWUK7O/WisfvF4kx6EEG+lswfsUgHAx8mARcfZkDLRwwtcicYjc9IH8TN+iSPkbXcjw++XGAAmQ4gPrXmX8Ts4u6UwV4Ugtv7NGykPLp5B2dkJpEI1T9AxxWFPLgykAOxCqDhTvtR6IqUJ4XaqRvIdwG5lyFJ1lYWJHsRywHIRCeSSLjKnFseccIcTQmjz7shIkLCcj/x2GoOB9yVZD9qrJ5+1v4tS9II6QxkmyjNXOIkmDpTkrsiyMy2O/QQhCMatzRZZGHCl8PyM5Tc+3qembRU02lcerfDdlRs9qb232+54zQDTb8XpB559k9eFqyKur35dbnLb2/okzL6r6uemGKk/uQPDmGbTJZVONzQMOrnKCUoDk9aMDgDLLMKQFuYtanqCai4OTu1EoKDuooEq6ZEQUKLs/DjGM4/Qp9HNBKXuSoIzyO2gIwTAWPiT7T/M0BzZIJU6S5sCUi0rMhumeCxgnSYmm05WiYEpKJxuHtc+8ZK5bsGHoyJk3QZIyXfq9xo3q71t0IEVWZY56LGUWBTBNdXSTgoKupiZr6iqyTj3HIWWlvjxVQwPbHKqOiO9F4wi51xYndZHyMXtiDmTR8BUOdBTA6ZjWZKFgwwEo/MYVnS2RhK+4PHUlaYQM0YkxQ850JZjG5nhKbImJ2ZqX9lvxhjtEXiOwtKL6/WrDV+KsUftAm69/JRDoAMnkyx7halB8a559VgO6cHzFwZkz1bAHdZU8r0/s+w1L90ycZAzIyy0UGSPNxWZZbIiTwinIWv3VLh6USWpB6JQdIgTbf3kmSVVlr8oLVZyuSuIDVALd8gBXdEHXvjosK61cv9ecOZPWJI0jZozsLCXTN99ExE4th/t1+XoSiIsBlZ00CC50twGeS6yt0hhwy7+xpj5Hylebz9CPe5twj577bO2I/PAoFxAsVTrKaDVGhaDER6gOKvhuVLWloOIZVeTc52LnKhePI0QWzPkkZYxanJ/mWXZAmb2lj7ySAdkIp6iSx+MkQyDGUViufPnZEoJiZ5KeMm/mhAeSoSNbvgkJXKGxlfq1Td8Dhx7UFyZ8/uCsYTOUmq94vIeFKLqyxpYrzCYtt2NVv6JzMNTZHj4jIUgumrK8BUJSXmTnDuvj4T1qffmXcqBGWZtrydUr7ZDuG+N9dKsw1uUcIV7eMI6wPMAKlkZkloOrosOkyFEArlLscNGMHEuxMajRoCLjtRy1ikynNJ3c3jbhumRo08xpAGkT/aAxNhZ+OF55/b4d0F3pv6OO3BV+cN0gO2TTFBpHm9Nd7V/39y8fOL23KcH2fRry1qTdJp/eJidwnlI/e1c66JmAWnkcL2vWboR16zvIAOIhJw5Y6AhzgFQ2n6GI/fNzn52r7EMPGe/04ld1rrKMQ+RxnBREY8BHWZqM4/Te8HwABDtUmJeZe5BtEf4dNOC019x/ZRgQjmkEcBnPpx8YhgyOxun3sIdbyc4dgUB+OYWp7W3NpydDm2Y8Y7LZFCpUf6jHe2BIGUB0oPj5cz7YZTmmz3oVXnndHk7mJmrTyXvB1V86ost1F6ng+zcthN/d+wJpP85AcYHRlxudSWIIEDsHhaxWHmAF85KOHw3UsN90Z0i4gNn3o2wxX2KQWCeKB7iGhK+0/2P2QPdMRdWdheiE/U8BOgNA37+4pMl3jsnnALRrIUCuV4uMQrYe/6W9rfmIZGhTyzIA6Ftl8frjPdQDFQExAZhz//Autz7xqsdg3hNvs3o2JSDecNNC+G0OiOFuFBpHh3cP+eBOsPNOva3MCcDit9bAon+sYIn/kUVytm44Tf/9d4Ldd92OzQIKSu5GZ2cKq9dsgHeWr4dXX18J5rdkd7SdA/ffCd6/W5+gXgk6Wb2rN8CyFevglddWQic598SCQQ4iLHQlj5NktWvyhGqx7qTQ4hD5YoT2Q121pfZFKzZxrBVWk8sBVxGVWitfTj+rOGVebW9t3icZ1tSyIQXopal59Fr9fmim7Yn+iQEiVee6AxAnXPkYPLbgbR+Oa+ofcfJecM0mZIj/kwOiZDF26PLkAUadn/LrEbBT3xwQAeCfr66Es85rsw4SskXOYQt19CRJClddOgjGDD+g4sygD6xesxEW/GUx3NeyCB565BViEkH5rpo0BMYMP7DKejfYemf8HR569OVcZHQA+eQIwbnK3R1HiABJFwctNjF7ku48yVDcnRLl/knkY6AhGaMWhsNlwQ4tagOtwXaIjaxrb23ezjDELtVS1SioP1yxB4owxMmXHu5IEqvPfchd+vWGxsG7+XszHngtYzl0WN1254uw6KWVjHf0aihB796ouLibI0/aGy5v/nD288231sK4C/4QiTO0bRxx2M5w47VDs+dNu6eeOcPL62TYsKETNmzszJvg6qQWnnPKcXvDdVceFfTf+K88DH96cjEDKvMQX6zsRJ48qXpApA3O/dPrMPmbc2DFyvWMMdYCiLze12DydQ/DylXrLTBShkh6yLHIgKEFdsIQbNBOKLuQA5W9G0JCpZAYzG6jwUnlOMI4K9Xk0duoOLkqPNDe2pwEgKgxQVpP/X73hb8cO2R3+MqEf2GfyTAhyoIWv72W3b/wS/Ph1TfWRD+t+T5HHNYPbr5+iH/m+LFtsH6DBZ/Q3sYHV8C0AGDMafvA5EutbfGNxWtg7L/NZkDKxkcCMODDO8NN3zvaA+LRo+/3k4yPn3Bgx+yBN17bCMMG7RG89/RZL8HXrneeeBE+lFWPbUyeNBjGDN/f17H47TUZYMu/7bZtgL47butDdej9BQsXw/jLZ0MHKTdZMMTFb60GpVooX++bMP7LbZka7TLCOMnoN+FHGtj3CzWV6u2arqekycGOGa7K29WHxEl60M6dK6xLu8ruioJf13kdA8Q60HUf0GlopfXvKcftAdddMaCqhe2s8x6Gl1+1zpDYQjVAAUTDyJAL0JLIzjh84AALAPGzs0ln5eXzFzS/Bh4uAXFqVeci8zdLYc/d+8DdvxwOpZLlSMuWr/eLxtp1HTDmU9Nh1eoNPkrSmbFokLj5t1SZR42bAkveWZeDCkKx+Vfv3iU4YL++cNbYg2DkKfuDYc/u7xv/ORfub33RA5EExFHj7oEl76wNgMqU37Z3CfbP6j0YRp5yIK/3+jkwrW1R1ow0A8jEqY5RdTVOkgKhfT/JGPVoAecN9xozVZ/F/upijFYuldxkwvUWCX5dB0Pz5ipDrGp21h/uUg90JyBSQQJA/FgbrGchLiEgShCiv3WGKDfquxIpDDx8F8EQzUkUOgjzoayx1RTO/dQhcMFnLJM2jO5LV7fD97/R6Cv8zg8XwD3TFvEwSBJm4x6UKjMFRPOMnJLu9yfGfggmXXSkb++xBW/AhP/7YA4fKVhA7O/vN427B955xzJ7ClySyX1i7MFw6UWDSb2vQ/NXZjH7qQMprMde0Y7otO0V2SIXA5BIqBX5dD6foUMoX1W8znJjy71fOJG6Ul9t0zIARG+4V60IPREHxwV/r7Xfd4desPee27NO+PAhO8GXx9vJb1bhz12c7Tn3f4v+sRKQ7en9FzLE1kxl5v0bV1clm5WA+LHPzmYHuDspHMeKASKqYzKfIbJUPvFTKCUJ3Plfp8Lee74va2bun96ES656BG798cnwof47ZdeefnYpnHvxbJFgJ3w/CYhN46ZkwMVV0zCO0LRx1y9HexnM4nLC2Ds9i7tq0lDmVHEM0QIX7u6RzNWw1rt+ORb23nOH7D2yej/6G1siF4qqsBJgsf5YHKEWh6jHSVJ8Yyq6jHMUmXYYCJc9VhShvRzb03bFUNDkbLN7mKEbv3WGWNtC0qOlKjlVijSuqczrN9AgaDe1bG2a3dC3k6YwZvi+wob4ABND2v0kIB4zeqow0+tMkL+bfWbwgN3hR98+xt+65nuPwYwHXoZzzjgIJpz/EX/9nItmwd9fWJa/DKrx1EFhbYjoZbYMMVRttTjE715zDBw3bB/f3vAz74YVKzdkjKw8Q9QACBned64+AY5v3JfU+ztYvsI6bSjYUNDW4vR01VkL1ObfXjJY/Aa56qwkfKUriFWdZWgQft94/TGA1OULDVrdC4am1TogFkGXTfxMzwCiZYhysGsAxNhhHl825tR9YfIk6lThgCjjCAdEVeZ4PJ+TRRr1v3b5IBhx0n7Z7dWrN8LoT02DNes6YLddtoN7bx0JDQ0WOn5zz/Nw48+ezFki7lNGJ0QKVwlAbBp3H7zzzjq2u0i2735fe0UjnHrCB3yXNZ39e1i6zIKp9TKjyjxq3N2wlNXL1VgfZvT/492uvfJYOPUEdPQ0nX0nLPUgre3qKB5HGNuGp9n06FiIxS/67+xRjmXLKDS+tDEXTrGiNsLuBcWKThVp85DN1+8jFEg103zkWvqnUhwiHTyx+jWVWXOq8PI5xyCD3cXxGYZ41SUWEF9/cw187LMWEPFcZe7V1FRmySJd/ziFMuy/FPrusA1MuW0kbNvbbiecOvMfcO0Nf/JdcOO1R3vP8zvL1sHpn54OGzZ0sKMAMr6Rq3lXXSoZ4n0BcNHvRlnabTeNgA8e0C9r29gxjxvzO++h1gDROGtseZFogaqcCcCvbxot6r0dOjtMGd2pQGM2JYu0rfGgdnpNyiLli5V3XmXqQKFxkpT+a/JpjFZ3Yca2e2rA171gaN69zhDDpWmzXykHiIMH7gK9epVgzmNvlZUzZkO0hcKBtPsu28J3vopOA195PrvM7pC99rC2TmPnev7FFXpVOaptv30vOGA/axczYPTXZ81mKG4ddG1M/tbj8OobqyzACnvbGWMOhC+PRy+8iTl8/MnF/tnhJ+0HX7scnRJXXjcXHvjjPz1Yy2M6pcrsGCICgdyXbFXbI48wavtJ3sv9t+eWwOcmzPRvJAGxadzdOfPUQA2Dm4/8yB7wo++cQup9Gz7XPF11jCCr0x0flWxrxZwt+vigiwo3uIaqcTGgC8eglb8o8HU/GEYBUWM6dPbV7/dseI4ExJPOeABGnrQXnPXRD8AHD9gBbr71ebjlNzY0Q/sz3yeMQ3Qqs57ma+89toe7b9k8p0d88sIH4IWXcoDNN+Y7WPrlD06EQz9kWdnrb66GM/59ZgawuXUL+mzbC+6/fRQYADZ/cx57HSb9xyPeISFRO7Qh3peH3SAQ0PFdKgGceMy+cMmFA+H9u6Hz66e3PAm/+u3TvvulDdGqzNJZYyOuDas2NrcTj90PLrlwkKj3Cbj1t0+JkBvFMaM5a3JppMrvFpqQHXLwtz3A03C5zECoCaBWQOtzHVEJdHG8dhX4NgEg1oGuZ4GuaP9SQDQDaPmKDdB3x238WIoBIq0/pjKjv5NCaQp779EH7r7lxCjI9uQNB4hU/TPtGQ/yf//4JN/0LXc8Az+79WnMyZKbr4znePRp1gZngqXP+Ox0eHPxGpK7xVZh4xC5ytwy+yU1HMkEUO++ax/Yd58dYLdd6B5lE5i+Gj55/jRYvXajZ7STMy8z2hBbZr9Ypt7tYd99dlTqXQWfPH8KrFmzMVSzlQwucruj6z8ZR+gWD7zvlolYnB93phgQz9gbfiAmnwdScYYrZXyazZJe0z3LGvvEhasnxmRdZe6JXq2xTjMJB3y4X8YGm07ZW63F7Fr59g+ehkfm16IySy8zrut9tmuAY456f34hXH0/c1Z/OOQgG+Iyf8FbcO/0l8q8ZQr777cDnP/pQ7JnjL3tq98xO0n0JWHOY2/AqtUWBOgTk77wEfjEWJvVxzCVs89vhZdfWRkkchiUeaGPIwvGU3DL7eb88ZANS4ZY7ad66+01MPGKB2HRS8uYF1gCYvX1roaJV8yCF/6xzL8fBzAODu7dtHZijhT82uVV0wC8nN0hW1UwYJy3XZTxxQCtiBOlZ1ghfY96HKIYUW5Cxthcd983MYfDBu0KgwbsAocf2g/Mtj35Z1TEeU8sgXumvQwPz10MGzs0tTdnQfnaPeCwncXWvZnl4xDzWZC9X3Cucgp33HwCHPgBaxP8+a+fhV/c/pwSh4hyWaeKDZUxgHj06CnZvzV1zkpuB7vr3yyRw20jYacdbSKHhX9dAudNeijwIJt7Rq2951cjYY/drUr7ymur4KzPz/AOD/yWJjzmqKqTO5g6TRjMtLYX4L9uewqWk33MDphsHCIyxKKAaOqd3rYIfnHbk7BixXoEHJaOjNsMHZsKQ4McF+RhVHTM2p6Ob/XL7st91AXOVS7mNHGckXrcNVsiV9vp+HAjRbLdov1d6bk6Q6zUQz18/4av/x+WhCEEQ4BPnK9v1dNFswNMAuIJY1thHYtDJANRnPsrXeO9SgnM/v0I2KaXBeuv/+cCmNZmHRfuT3qQJSAeM3pKZNugHeIy4etpx+8D37gCEznMeOAlmP3Iq8ErOwD/+KgDYdjgPf398V/5Azz+5zeDQHQJiHdNfR7WrkWvtAPljs5OMFlujOf6uUXvwLN/XwoujpMCrPu3ZIh3TXkW1q2zjJy6knxasWVr4blFS2296137uCjQF9VV41CdDOMQQ4DUnBYUYKXazQFSZ5ZFvcqxUB5+nfZWMBt6eDbWvcw93sGVGvj0mQdA87mYm/eV11bDP15ZDUfnmWpkxuxK9bmV2toQbbZPmd3EAAAZq0lEQVQZ83f8WMsQ3YRHczqfev6+H5dp5i3+zc/Q4fLZCX+EZ543XuOwrCtv4xBDhkjVWGSLYZp+E04zdJBT4Su/tXzCAOjXvjsvCEGxcYiYpst6ma3zQ7JXrg3I+En+WzJEdKog2GdgkzdEWTi2o4OcZHi2GhmfyJkWqr26Ksrvh/oQ3aeMC2ReF3s8psYWUYFdh+jjKDa+qh8NxUvU4xBJEIqmJtNrPXHfnJ8y8byDM5vgo/MWwwsvr4La4xAR5jRAjMUhWhYgTpuz1CszpH981P5webNNN2bqOPlfZ2T/d+AnJ6j5ranMkkVieR6nJxM5FB/O+KRN+DAVVq0yCR8QQCQgjhpn4hA5IOKiYUEyjJMUIJcFZnOV2QDikqVrMm9yVl6c9udBLv+HFnOoxyHyvpLyEcyNxDHq5RkkiTjJvAv4sRGkT+X3KcoYY+E54ffueduha7OuMtcy23q4TO07VXDglGOI0YHItBVM3PDdrw6C4xutOvrnp5bAhV961IOhZJpuous2xGIpqUwih/PzRA6moaefWQJr1qJDKHvLfNJSa5mxNx7U34bomL/v/egJuGvq33NZraTWqRIyRA3UKWOUQCNBUwKijUN0nm4rD80XGDguCuUz1GMa3fvyOmO2uRC+fHl/MiFP+JpL71m0+63V5ABaA7VK8hUHyJ6bgPV8iErfakyQPtbT9ysBoqLgsLcw920coqYyR/IFkkppyqzttmuAabefCtv3sXF+N9/6DPzyjudI+Gw48UxVocp8n5eR2uBk95vsXnfdchrstYdN5GDSfI05ZxomkpX2TlKBCR6fctvoLHDd/P312aXwuYltrAkJiKPG3VsmDhHfTbMbYsXGWTNMbN27yzJPp2WS0/26L5+hFkeoO658PsPcNEBBzoG7BW2ez9C5QRjo5tqDBnrFrmUtKTOvqJq9iQCxpyd6vf5icY7VqMx0tbars20jZIgtsMEcFEGDVrLRjkeIaucqf/rM/tD8eZd5B+CTFz4IL77ssmzzAYztu/Rfx2byWC/zfSRMhU4v/LdxrAweuDv88FuYyOHOKYvg+p8syF6Kn6vskqhi1J1RT793TSMcOxRDlj7zxdbMKeImfagyO0AMU2YVj/PTAXHJ0rV+C2FmO6XRzd6cGIIaBSsOxHwGFZVPC6C244QwzjxBA/MWlz1XWfd8c29z+ThHuqCEjDkGmj0Hhqbmusrcs/1bU+2VGGLlVTjNvcyUIbaI5A5kwFFcI6v/brtsC7/+6fHQLz/D5Mmnl8AFl1l1udIKb1VmDogOlGxz9r+SLX79K4Nh+Ik2kYP5O+/SB2Hh35b431Y8wtzEucqnHr8vXHvlMP/8b3//HNxw0wL/W2eImJFcMkEnKVWfXet0AZAMsWncXZgPMQMWbruz7647QmLeYvcSkrVRYKHyyuvly6OaTA+YJ4hOhl1X2F2RsrHxVdN0qqpQPQ5RdJc3dkem/Ka4X/xcZl1dNRPKht2EgOjwjqrF1Ivo0jj1akjgh98aCkd+ZFffQxOvbIf5T7zlt3dx+yEHuPKAqG8ftIkcmnwih5deWQlnn2f3Czvs8GcUK3F65jGTBOL+O8bADu+zO3uWLV8Hp58z1YfM2LAbakO8N5IPESHfgSEFcHntKkVlNgwxK5On2s8AVOQL5HU6qKP9E2a70eMQQzbmFh46Zm1XKnXmh3RJ+ajWQRcAXqcE9mriCIvaOqvCtZofrjPEmruu5woWY4ihukoBamB2pgkC4gljW2Dd+k7nNsVjI3OwoQBpgqKvuXwgnHzsXv4lH5n3Blx29XwRVYd9QAHCXJWAeMzo+9Q4RMq8zjy9P1z2RUzkYLbp3XLH31igsEUYApBKoPGVlwyCj45E0DOHQs36wz/zvIUcEK0NkeZDjAUtY2gQldlhdcAQz84ZotvZoZz7LMEmZIa2f7lqHIKNUzdrjkNUEr5qgdaV4ghjThO8rtsIY+V6bobFa64D4ubo9QptjvvYB+CSCw61kyFNoXF0q1IirnqYifaZT/SHL/67jW80KtBxY2fAxo2ExUXO0TVqsgHDwQPwxD5zqNS5Fz8Mby91Z4/wYGM3bZ2Q6FSRKjNnkVIN/dUPT4JDDrJeYvPeZ547M9t1Ilkhd0qE8YFHfmR3+On3cF92++OvwyVX/SHPWxhniFIe/G3B0AGYxrIChnj2XVmuRBlv6PpIsrSw/jCFF+3n0OamsTQ5bPAZXz4YB27B0cErHIjac5q3YMtWld17OUA0wVr1c5kVNZl+Wu0zd8f9cz/VH0afuk+2n9dMjIMO2NGng3p7yToY/emHBDHCwWWCus88/QOwfn0nrFvfkf3fzNx9yLEES5aug1HnPEA0YwypQUdKCoMH7gbXXXEkO/HPZIRuvqI9C8SWLNCRNS1Ob+DhuwY2RHlogAvSdizL9yWZpFQ+mjvAg1VeSGNJlJngfTv0NZYXU431OERcFFD+nKOxQ+ZzGIvFIeYzsXvjEDU1G22WbGteSFO5So0fxWMh7Wu6SCCfRUVELpb0W1eyQ28GrrKxvbV5G3MMqXHD2Z379b9N3gPHD9sdvqvlIgSAmQ++Bl/97l+ETAiIJza+H779H0oeQ1Jiysx/wnU3/oXMYD3ObO89+8BtPz0e+mxnQ2xeeX01XHb1PHjRn90cjyN0zTlQCQHxXgHq6GhAgNLTXNn78eBmCXCud+KgZ6dlOdtaTaDpPOFZ95KM3R70CCix8BcrD2V9mnqqq6wK64uEtKisklzs+rnKoac+HldRlDFu0um4vL21eScDiCY1iE1NEs1JgoJpTImKXb9fLLzG9Vm/vtvA9DtOzMMysCfnL3gbvnb9QnhriVFV3R8HpV137g1Tf32Sen5wR0cKD899E771g4XwznJzALoFQp6liQ/MT55xIEw8719gaus/4Ue/+GsWB2j/8Dn8vvqgtiqzZIgWECnQhENdyKewk6x8bpdTy1c6H0bkEZTvxse//s4USLMnxC4fr+KTXmPskyRLoHY/DcjxGg/PsTimxSFKE4L9dp4IetC2WgI9yMqDcjCBi4Mu/yba+MBxTMd0+C03/ZU0hWfmtjUfmgxrapmWAjTVgaw6IJOfrCv9d9CBO4Dx7JoB2tlpD4NfvtKkxKJAGCqd5u5e798uAERjuzJAumFjfo4KiTPzw5SmdcqBxpx7fHD/vvDX52zsHgUMql3FgMROvxQaSgn06WPT/pu/las2iDhEMVmEfFlfKkCT448SxqI5G0JGS+XW1Gz6TSs6M9ziQhYa2mfUPOfjEEmfF40jrORssX2O2wzpV7PfDNl1IJ83OWhxkrE4QveViY9OOfpUMwNo46b8rNt0wJim6f1z2yaMSYY1zbwuhfTKTdd0vaXqeyCmYlRhwGaGtNjqXVSVsc/x1sOy0u6o/3ZTOq/P06Ic0Ei1NdVHgJ3KiwBfgVURNsbLI0+zAM7ZK7evyThETb0MgUYDENdqOIZsR6mqMXk4W2jc7wgL14GLQi1fOmKy8OvVjLnqZ0iXS6Tp5Pa2CdcZhtiUAkyjAzzGdgJ1QUhRv695YLGTau8fDkASGNj4DhI18N0o9NhIyhj0788HsWs3HB9VyBckbkWbpgYsVEbvYaZb4RTVlKYTY+oqCxwKQV17v6C8BD6vAtsbAbNV7YPlw3iwf7vJ1kl3+gRhNsR+6cOE5LGiuGhxwA1BzsVJcuZXVO3uMqzVXkGantTeNuHBpLHxd33Sfv3eTCG1GUDrf1tYD+iBzFTIGEBayiAy2XgeIYFaDm7dhqaxAZnPUKpB1QF4Tre8vTBuNwwBTHP8xJw1cWZIJ72m2jJ1UGGGlcrH4vzcokQZGiP2UdVUhgYRAFISvtKDovTQoBDAKsUhxlhlJYDcQibb8mTl+j3nzJm0JmPPQ0e23AwJXLCFCFcXw/dAUTVDAy+nx1FapIEjrv6UJcbCIjjLtbY7GhQuQYqynZCFhqBkWSL30oZxe7H8hZH6hFdZry8OAlINZfLJtPrCaUL7y/UpBTmrvvLvjMq4HsKC8nC4dMOmkkcaE0BWP7745IwvorU9t3mmfgpw89zW5i/4BWnIiBkDSqVkgXw9aXOp3+cfrGf7R2c7MY8vMwfluidN2KB5Z91kjE0rZ2vC+6EKrcXpuV7C8jrL9fdjamj+gLN7udYp6Do4ianGVccRlo1T5Iy7Ypxk3hEUwDQw5IwyHicp30V+P9sXoZptDZw+0IAFu3Ms5rZO9300RhtbMOXiET4XA+HNA4am1U5Ij5rXOuExxtCHNbU8mAJsnrMoN19fbKEtlxs02j1xTe5AUFRnTY3VQAU7qHgcImeaWnIDpa4MFK1HNCuv2Am73bZGvLOaasqAiuQLpAlfLSgST66LQxQjS/e6hqw05nWtxPo4a5TDmstn4684MXWsNJwQVkYOdAXGoMJ8bd1bFiCmKcye29Z8slzE4ajTZg5s6AXzAdJe5UQW/Rj0X/1+d4TvxAdc2L/k2TL5Ap1UFGi0wV/MHhgb2FXaOxnlsz/KxUki0MZVNami83eMM1WNfcprNI4ztnhUjEP04BLGFtqYQbQHOigKmXr5OET3zvFzlXWQq8zufM0B3MeAVPb/FsZAOjo3dg6aN3vinwNANBcam2be2AnpxZrQdaDrDqCLDwfev+GENxPFqUzBSsvyBeZlGeXJE3+ivyJYqal6qw1iOinDlR7jALnk+ItPamXnCU23L1Q/B5Q25C/cv+yAksqtx/mFjEyP8xNhMmq+QG6PdekONTuhBTrZq12Jk9R2togRlDPuPEyy8rnKQRBVLA5RgimXBd+yOPvdXCBJbYcqIA5tmtY3SRrmpinY7AL1v83QA0XUkTIcXpyj63VQ9iZF2qjMBiQbk6AuF1EJ6dnvTBTJDvPfArZlaLpaXyZ2OJljgdCVANapkn59yeXNAI68IK4/KHu4cCBcSoCUQKoBi32z8lvkkOWRhZHMdhaH6BuJM+6YHOWvVzO+NsMUs2Nk4epk7bAnZ355FZUg+C6NI2YclJaS9hQAk+HlJdz3j7HF+n20tWhDolj/SLWOsywXxkA9u9bAg4HMMbXYAYjLeygHNZcvfANfXvWLIj5IoHLAkKmDLAyI27Iws419DjGHAyQFYjoWNfk01Taq7mrMVOz0kHGc2GeEOUXsnwhoReIQw3emgOi+Dn3n7H70XOUwTrLcsaRcH9LYHi5kFFAqAfbmgj8uIyxLO2HIvFnNz0p5woUKAIaNbD0Rkk6zpa/PlvAC7w0ZYqyvgl1O2g09QhAgFZmleX+GoTPSOCCZYFheCxwRAImpmH1xyxDjcZIaQGtgWBkgQwCiBC8GmhZgQtWYsqxsLSL7q3FCcdXS/ZITTi5w9n4IQI6pyrngGS4xm3ivsgaQogLVK622L5kpfz+36IVzFbnzFjKPV6adyUfnzho/W5NHBUTz4LDTph2TNjTcC0nIFLeQF3uXiVFMzYixLzePPDu0aBMMf53dayy0AMgFu04KxgeKFFnoFJfxhwXri56rzJ0UrjOqjkMkmWxsUoTQjkknElWfKahr9kUJgJQFyoUH5Q/3LrNnI/kudbAS3EmdVUVUag7kCJAxfXLTT98UYFln0jFq/syL3VkYgRBRQDRPDh45/ZBeSWlqCnCQ9lqhusLrr99HUCnff8W9n76HI9ux8AvgCWrSvuWecZORr+EcHN0wL5zPUGTGoRM8q9k3xh09kmW5x2TsnfTEavKhGonLR4xZBvL5HKkF5Msr1UJqYmE2tK9l/0tZ3OSk7FCCrZzRMmjcLpQiDrGMLVKTj0MmOtBigL2FguFTHUnDuMdmXrSwHBSXBURT8IjhLe/brgTfKCUwMQXAFCabHuDfxS3WugKTVZmhWg0AK1JjcQDn9izntOB2rIL5DPMJqiZ8JcoigpqcXkVta9ITq8sXWxQ4s+NHdFKwdoMSr+mOj0q2Na1OurjR+rV4hyCfIfuA0hMcaiNdky/GDjf/lE1TSBNIf5qs2vAlszWvkkQVAdFVMHjEjCG9SqVvAsDJWRuRv0oEuX5fV0Upa2MOE0oJZYYZmtAuH+N6vkCpEmsD2F4Lvw+fPLrKjvVpQEpfoWI+w26xd2oyx98v1GTQQWVK0XeWRxjgffuWFMhxwQhjDmvKZyjSfNEFybDADDTJy0iQw/shIIYgW+SZ+DiqBDyb5H4KM9JSafLcmV98vGh7hQHRVWi2+SVJ6TJI0s/QRupAV0ucoq6eaoMziEPkCffw3GLFbugmKh++dMDH4gg50OGvkNFS+QLQFHGS2X3mYNbVewlUyBWpNx8Zo8ao7N1QzXNqKAMVgtx0N0pW3iFNXiAWxhPaCTX5eDxlXD4rO2eH4TXn+WbOGJLmiwOl65Huy2eoyVcUgHrquTTt+NjctosxM3HBhqoGRFfv0FEt5ozI0wq2U38s6AFtBS6w4mbFcjRhj9dYXw4Y2geSwKb/5qCJ003sDhNb8yibcm1TOx/ed3f1QGbKphmTy4tR4OMAy4HBTWof7pPPjNCB4gCW91glgMS3wKMEKIDz+65PNb4eiUPMX8AuNF0ZCwXGIHv1cHHc7JM9hRntbc1NtchRMyAObpp2ZAM0mA3RJTmgY2yR2mW0T/beuq+zLD6xFNUv3zVBD2x3zEDLF0gHhabO2fvIYjwwKJNKL89ZLgsjQZTJWimez1A6o+LyRdXd/MWlairfj4KwFidJx6T3MOd5Dymou4mE9SNwUgalAWfMKUMXBV+/zGcYnPts2SwPDSq/64SOka7aEvXytUBTbWUyy0GpdFQ1arKcI7W1bNKGNbXcDFBPG1Z9BypAV2ZVdyqmZYbBIb+Rc0YkUMVX/mL7l8MlrBDARvdXy9AVDiAcbKqPI5RgRVVjBkDRhK/uYHkahxiG8WgASxcZDSA1AKLy6XGIGjMMU6XRtjnPLB9H6Ji0HMtugascqB1jpdXPji6VSNOftLdNGF9rHTUzRNPgoEFTtt9mj95mq9/htQrw3iwXVzPKOiWc04POMkRLy8LEjmfs3xjL4i1KkIupyfpzwqmgxRuWyReobaOTyQ7i7aKtjYIUY3h5Z+jtkJ6KxEnG4ghD5wUH+xhIxazOIcvi44V5lJlaJRZM/0oaWBW5xuFcjiU+dzc/IKYAT5VWrj+qiDc5hjtdAkRT6dCmaYcl0NAOADvKLgnVGS7Ge/O+ztw0a1GohvEjRGXqKdwXbGvj5aXvWtvvy1kklo+H8UgWgnGGucczOEKUgGb+0jE11rbPgY56wmPvR0GTy8dZaPB++afBLYQ5lHmTbQi60ulBTQZSvhhji6nUODlxzJQ/V1mXjzPSMN8iBToqiwRy/bcrvXkBMU3hnY5Sw3GV4gwrEbAuA2IGiiOnH5skpekpQP0Ygko9Hjk3t+JqK7zKlgrGVe8YwKJqFgb3UDbIF6s4KFFW6stQNTTBw6O0HIdq+R47TN7BF99WmF0lu1EyUCNM1sGyXKA01baIV1gDFgQinbkxoFLyXbqAbJnwlcKVBrB4v3zSiC2cHa7sSDpGlNuBUnFa5g90CyCauo4a3nJ8QwNM1ZgiFSacqHHWqL3E1lueq6yx1VaqqDLde8V8hsTEqLUR1O87WZPPcRr8EmXLU40twcOt2PcPzlXWQD1s171LZaBH0HPtakBv15P8nalZVmzNs4BN4gjJoVLcLmlldvKhnEUz74ThNbZ+Ut6DtrtDjxiQcYghsOqgG2N2RVTq2HcqCj9df85sx4PO5OOxvcnVttBtgGgabhzecmjaC/5HsyluvUBmu7Rr8hdLoOCYSD4P2LmcPl29H4MCSLz6KQcyAh0O3/CZMN8iH+xl1e+qzlUO9wG7/qWDV3rbnXzuGU3NxvIao+VfMHbus2PdQf1iAOhhNkS1VXb+aPK5bx6+nwKEZPHSGK0fN2JrHleDJZhqcY4YJxmTj75LtaDTfc+nCzs7k3/VstbU2ka3AqIRYtDpU7bvtbH3DZCk50Ga+JCcWgV8d5TTQSp8tzKrMs7QIPmWrafoSo/PURajySIXAckO1d9Z9SHzouzJtaXXR8r7mkL2amPteHZpyQRdTY7hlWVt8ggDAj5YD7pVwomjsbbwu3Q5rCU4V7mrTK5I+dgzlWhCj83ejhTg52uSNZfJfIZdbbHbAdEJdNSomQMbUrg+hfQUPgHibCtUN/jrbZ33JQDF2aJV4/h5IpSaUmM/Nx9ywIipte664Eq+k3n/aizSAkIApPlFp4ZG8y06dVOky3ItafJF1V0RO2leQi9P1F2fzovkW6Sn5jH5LJjRPkG2FMZJcgYds1Ui88J35gxNY752TOSAS8aHC8CmDNDaP+W5yiFzLe7h5qCObcUW4K5CUvny5gyUtKPzUpr2vztb7DFAdEIOG94yNG2AcwGSswHSnbpT+K2jrlr3B+cDTgJk8NLF1PHQheIqqlU+p9HzOD0aJ8kDsSXLqyYOsfpAbQSocIdL2ThEn5CHMz73S04Y6lV2oByLI8T7+BFlCJBk+1rCV6oMcAcQX644sy0fhyjbxdFR1NnSo7NxeQpwRwrpz93peD3VWo8DohO8sfHRPh39VjSWABpNukWAZH9I011NvsUUYNueesHNW6/GssJEWnQCOZZoMmALOmYZC3OahBMgxg69GkszcFWRz1Bn+aE9ULJcydr03+HJfPHnOMuiz+Ek1vMoeoWXsqzoucrxEBbK4qTtT7JInGBdYWm4OHKvTTi+9PFe5LkiqjPt4R6ZWRsBYHWawusA6XMJwBwAeCRZtWFuV2ILq5F0kwFiNULVn633QL0H6j2wOXrgfwHFW6PCrG4g0wAAAABJRU5ErkJggg==) no-repeat;
                background-size: 100% 100%;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 40px;
                text-align: center;
                z-index: 2;
                font-weight: 500;
                outline: none !important;
                -webkit-tap-highlight-color: transparent !important;
                border: none !important;
              }
            </style>
            <button class="s">
              <!--                            打开APP-->
            </button>
          </script>
        </template>
        <!-- 非微信环境的slot -->

        <template v-slot:unWeixin>
          <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="openApp" type="danger"></div>
          <span v-else class="openApp" @click="unInstall"></span>
        </template>
      </open-tag>
    </div>

    <!--    <div class="openApp">-->
    <!--      打开APP-->
    <!--    </div>-->


    <!--    正文-->
    <div class="content">
      <div class="content-top">{{ content }}
        <span class="labels" v-for="(item, index) in labels" :key="index">
          {{ item }}
        </span>
      </div>
      <!-- <div class="labelList">
        <span class="labels" v-for="(item, index) in labels" :key="index">
          {{ item }}
        </span>
      </div> -->
      <div class="content-bottom">
        <span class="content-bottom-span" style="vertical-align: middle; font-size: 12px">{{ publishTime }}</span>
        <span class="content-bottom-span" style="vertical-align: middle; font-size: 12px;margin-left: 4px">{{
            location.city ? location.city : '未知'
          }}</span>
        <img v-if="location.address" style=" line-height: 40px; vertical-align: middle; margin-left: 5px"
             src="../assets/location.svg"/>
        <span style="line-height: 41px; vertical-align: middle; font-size: 12px">{{
            location.point ? location.point : location.address
          }}</span>
      </div>
    </div>

    <!--  评论和展示自我汇集  -->
    <div class="buttom">
      <div>
        <div class="buttom-top">
          <span @click="changeCut(1)" class="pl" :class="{ 'dark': cut === 1 }">
              <img v-if="cut === 1" class="pl-img" src="@/assets/line1.svg" alt="">
           <span>评论</span>
          </span>
          <!-- v-if="inviteIf" -->
          <span @click="changeCut(2)" class="self" v-if="inviteIf" :class="{ 'dark': cut === 2 }">
            <img v-if="cut === 2" class="self-img" src="@/assets/line.svg" alt="">
            <span class="xc">相册合集
                        <img class="zw" src="../assets/zw.png">

            </span>
          </span>
        </div>
        <!-- 评论 -->
        <div v-show="cut === 1">
          <div v-if="levelcommentList.length > 0" class="comment" v-for="(item, index) in levelcommentList"
               :key="index">
            <div class="comment-top" :class="index === levelcommentList.length - 1 ? 'new-comment-top' : ''">
              <!-- 评论点赞添加遮罩 -->
              <div class="navgiteApp">
                <open-tag :extinfo="getList.postId">
                  <!-- 微信环境的solt -->

                  <template v-slot:weixin>
                    <script type="text/wxtag-template">
                      <style>
                        .s {
                          width: 100px;
                          height: 70px;
                          font-size: 13px;
                          color: #FFFFFF;
                          line-height: 35px;
                          text-align: center;
                          z-index: 222;
                          background: none !important;
                          outline: none !important;
                          -webkit-tap-highlight-color: transparent !important;
                          border: none !important;
                        }
                      </style>
                      <button class="s">
                      </button>
                    </script>
                  </template>
                  <!-- 非微信环境的slot -->

                  <template v-slot:unWeixin>
                    <div v-if="!isAndroid() || isWeibo()" @click="showModal"
                         style="position: absolute;left:0;width:100%;height:70px;" type="danger"></div>
                    <span v-else style="display: block;position: absolute;left:0;width:100%;height:70px;"
                          @click="unInstall"></span>
                  </template>
                </open-tag>
              </div>
              <div class="comment-top-left">
                <!-- <van-image style="width: 32px;height: 32px" radius="8px" :src="item.fromUser.avatar"></van-image> -->
                <div class="comment-canvas">
                  <canvas class="canvas-class" :id="'myCanvas' + index"></canvas>
                  <div class="canvas-class-div" ></div>
                </div>
                <!-- <div style="margin-left: 0px">
                  <van-image width="32px" height="32px" fit="cover" radius="50%" :src="item.fromUser.avatar" />
                </div> -->
                <!-- <van-image width="32px" height="32px" fit="cover" radius="50%" :src="item.fromUser.avatar" /> -->
                <div class="comment-buttom">
                  <span class="nick">{{ item.fromUser.nickname }}</span>
                  <span v-if="item.fromUser.userId === creator.userId" class="zz">作者</span>
                  <div class="pl-div">
                    <div v-html="item.comment" class="comment-buttom-span"></div>
                    <van-image v-if="item.image" style="width: 106px;height: 106px; margin-top:5px" fit="cover"
                               radius="8px" :src="item.image.url"></van-image>
                  </div>
                  <span class="pl-div-span">
                    <span>{{ item.publishTime }}</span>
                    <span style="margin-left: 5px">{{ item.city }}</span>
                    <span class="hf">回复</span>
                  </span>
                </div>
              </div>
              <div class="comment-top-right">
                <img src="../assets/like_fault1.svg"/>
                <div v-if="item.likesShow !== '0'" style="color: #666666">{{ item.likesShow }}</div>
              </div>
            </div>

          </div>
          <!-- 发布第一条评论添加打开app -->
          <div class="noComment" v-if="levelcommentList.length <= 0">
            <open-tag :extinfo="getList.postId" style="display: flex">
              <!-- 微信环境的solt -->

              <template v-slot:weixin>
                <script type="text/wxtag-template">
                  <style>
                    .btn {
                      font-size: 14px;
                      color: #384594;
                      font-weight: 700;
                      margin-right: 20px;
                      background: none !important;
                      outline: none !important;
                      -webkit-tap-highlight-color: transparent !important;
                      border: none !important;
                      width: 1000px;
                      height: 50px;
                    }
                  </style>
                  <button class="btn">
                  </button>
                </script>
              </template>
              <!-- 非微信环境的slot -->

              <template v-slot:unWeixin>
                <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="unWexinOpenApp" type="danger"></div>
                <span v-else class="unWexinOpenApp" @click="unInstall"></span>
              </template>
            </open-tag>
          </div>

          <div v-if="levelcommentList.length <= 0" class="noData">
            <div class="first">发布第一条评论吧~</div>
          </div>
          <div v-if="levelcommentList.length > 0"
               style="width: 100%;height: 50px; display: flex;justify-content: center; align-items: center;padding-top:0.35rem;padding-bottom:2.5rem;">
            <open-tag v-if="levelcommentList.length > 0" :extinfo="getList.postId">
              <!-- 微信环境的solt -->

              <template v-slot:weixin>
                <script type="text/wxtag-template">
                  <style>
                  </style>
                  <button style="width: 100%;                                                                                                                              color:#071679;">
                    APP内查看更多
                  </button>
                </script>
              </template>
              <!-- 非微信环境的slot -->

              <template v-slot:unWeixin>
                <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="gd">APP内查看更多</div>
                <span v-else class="gd" @click="unInstall">APP内查看更多</span>
              </template>
            </open-tag>
          </div>
        </div>

        <!-- 自我汇集 -->
        <div v-show="cut === 2 && momentList.length > 0">
          <div class="comment-2" v-for="(item, indx) in momentList" :key="indx"
               :class="indx === momentList.length - 1 ? 'new-comment-2' : ''">
            <!-- 自我汇集蒙版 -->
            <div class="selfCut">
              <open-tag :extinfo="getList.postId" style=" position: absolute;
                                  top: 0;width:1000px;height:190px; background-color:transparent;">
                <!-- 微信环境的solt -->

                <template v-slot:weixin>
                  <script type="text/wxtag-template">
                    <style>
                      .btn {
                        font-size: 14px;
                        color: #384594;
                        font-weight: 700;
                        margin-right: 20px;
                        background: none !important;
                        outline: none !important;
                        -webkit-tap-highlight-color: transparent !important;
                        border: none !important;
                        width: 1000px;
                        height: 190px;
                      }
                    </style>
                    <button class="btn">
                    </button>
                  </script>
                </template>
                <!-- 非微信环境的slot -->

                <template v-slot:unWeixin>
                  <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="selfCutOpenApp" type="danger"></div>
                  <span v-else class="selfCutOpenApp" @click="unInstall"></span>
                </template>
              </open-tag>
            </div>
            <!-- 蒙版 -->
            <div class="overlay" v-if="item.publicity === 'invite'">
              <div class="overlay-div">仅「聚一聚」可见</div>
            </div>
            <div class="comment-top" style="border:none !important;width:100% !important;">
              <div class="comment-top-left-2">
                <!-- <img :src="item.creator.avatar" /> -->
                <div class="comment-canvas"
                     style="margin-left: 0px;width:34px;height:35px;display: inline-block;vertical-align: middle;">
                  <canvas :id="'avatar' + indx"
                          style="position: absolute; width: 30px; height: 30px; margin: auto; inset: 0px;top:1px;z-index: -1;"></canvas>
                  <div style="width:32px;height:32px;"></div>
                </div>
                <span>{{ item.creator.nickname }}</span>
              </div>
            </div>
            <div class="comment-buttom-2">
              <div class="comment-buttom-div">
                {{ item.momentPost.content }}
              </div>
              <!--              小组可见-->
              <div v-if="item.publicity === 'invite'" class="comment-buttom-imgs-2">
                <img class="kejian" v-for="item in 3" src="../assets/picture.png" alt=""/>
              </div>

              <!--图片--> <!--item.momentPost.images.length-->
              <div v-if="item.publicity !== 'invite' && item.momentPost.images !== null && item.momentPost.images"
                   :class="{ 'comment-buttom-imgs-2': item.momentPost.images.length >= 3, 'image-item': item.momentPost.images.length <= 2 }"
                   class="comment-buttom-imgs-2-3">
                <van-image class="picture" :class="{ 'image-item': item.momentPost.images.length <= 2 }" fit="cover"
                           radius="8px" v-for="(i, ind) in item.momentPost.images.slice(0, 3)" :key="ind"
                           :src="i.url"></van-image>
              </div>
              <!--视频-->
              <div
                  v-else-if="item.publicity !== 'invite' && item.momentPost.images === null && item.momentPost.video !== null"
                  class="comment-buttom-imgs-2-3">
                <van-image class="image-item" fit="cover" radius="8px" :src="item.momentPost.video.image.url"
                           width="106" height="106">
                  <img class="image-item-img" src="../assets/play.svg">
                </van-image>
              </div>
              <div class="img-num"
                   v-if="item.momentPost.images !== null && item.momentPost.images.length > 3 && item.publicity !== 'invite'">
                {{ item.momentPost.images.length - 3 }}+
              </div>
              <div class="comment-buttom-time ">
                {{ item.momentPost.publishTime }}
              </div>
            </div>
          </div>
          <!--                    <div class="hj">app内查看更多</div>-->
          <div
              style="width: 100%;height: 50px; background-color: transparent; display: flex;justify-content: center; align-items: center;padding-top:0.7rem;padding-bottom:2.5rem;">
            <open-tag :extinfo="getList.postId">
              <!-- 微信环境的solt -->

              <template v-slot:weixin>
                <script type="text/wxtag-template">
                  <style>
                    .appStyle {
                      width: 1000px;
                      height: auto;
                      line-height: 50px;
                      text-align: center;
                      font-size: 13px;
                      outline: none !important;
                      background-color: transparent;
                      /*-webkit-tap-highlight-color: transparent !important;*/
                      /*border: none !important;*/
                      color: #071679;
                    }
                  </style>
                  <button class="appStyle">
                    APP内查看更多
                  </button>
                </script>
              </template>
              <!-- 非微信环境的slot -->

              <template v-slot:unWeixin>
                <div v-if="!isAndroid() || isWeibo()" @click="showModal" class="hj">APP内查看更多</div>
                <span v-else class="hj" @click="unInstall">APP内查看更多</span>
              </template>
            </open-tag>
          </div>

        </div>
        <!--        无自我汇集-->
        <div v-if="cut === 2 && momentList.length <= 0" class="noData">
          <div v-if="!isAndroid() || isWeibo()" class="no-hj">暂无汇集</div>
          <span v-else class="no-hj" @click="unInstall">APP内查看更多</span>
        </div>
      </div>

      <!--     tab遮罩层-->
      <div style=" position: fixed; bottom: 0;left: 0;  width: 100%;height: 60px; display: flex;justify-content: center; align-items: center; z-index: 100">
        <open-tag :extinfo="getList.postId">
          <!-- 微信环境的solt -->

          <template v-slot:weixin>
            <script type="text/wxtag-template">
              <style>
              </style>
              <div style="width:1000px;height: 60px;border-top: 1px solid #EEEEEE;opacity: .1;"></div>
            </script>
          </template>
          <!-- 非微信环境的slot -->
          <template v-slot:unWeixin>
            <div @click="showModal" class="search" style="opacity: .1; transform: translate(-50%, 0);"></div>
          </template>
        </open-tag>
      </div>


      <!--      评论tab-->
      <div v-if="cut === 1" @click="showModal" class="search">
        <div class="dianzan">
          <img src="../assets/new_like_bottom.svg"/>
          <span style="color: #232323;" v-if="likes !== '0'">{{ likes }}</span>
        </div>
        <div class="dianzan">
          <img src="../assets/new_collect.svg" alt=""/>
          <span style="color: #232323;" v-if="favorites !== '0'">{{ favorites }}</span>
        </div>
        <div class="dianzan">
          <img src="../assets/new_message_bottom.svg"/>
          <span style="color: #232323;" v-if="comments !== '0'">{{ comments }}</span>
        </div>

      </div>

      <!--展示更多汇集tab-->
      <div class="search" v-if="cut === 2">
        <div class="dianzan">
          <img src="../assets/new_like_bottom.svg"/>
          <span style="color: #232323;" v-if="likes !== '0'">{{ likes }}</span>
        </div>
        <!-- <div class="dianzan" v-if="momentList.length < 1">
          <img src="../assets/camera.png" />
        </div> -->
        <div class="dianzan">
          <img src="../assets/new_collect.svg"/>
          <span style="color: #232323;" v-if="favorites !== '0'">{{ favorites }}</span>
        </div>
        <div class="dianzan">
          <img src="../assets/paizhao.svg"/>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="top">
      <p>温馨提示：</p>
      <p>1.点击右上角菜单。</p>
      <p>2.选择【浏览器打开】，再操作</p>
      <div class="close" @click="show = false">关闭</div>
    </van-popup>

  </div>
</template>

<script>
import {
  getList,
  MomentByPostId,
  getallPayedIf,
  getForLevel,
  webClick
} from "@/api/post"
import {tools} from '@/utils'
import {getURLParameters} from '@/utils/getSearch'
import router from "@/router";
import {clip} from '@/utils/clip'
import LabelText from '@/components/LabelText.vue'
import {ImagePreview} from 'vant';
import dayjs from "dayjs"
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import cmxt from "@/assets/cmxtb.png"
import btn_bg from '@/assets/btn_bg.svg'

export default {
  name: "images",
  components: {
    LabelText
  },
  data() {
    return {
      btn_bg: btn_bg,
      cmxt: cmxt,
      params: {},
      show: false,
      //出发地
      fromCity: '',
      //目的地
      toCity: '',
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true, // 动态分页器，分页器小点的数量部分隐藏
          dynamicMainBullets: 5, // 动态分页器的主指示点数量

        }
      },//轮播图初始化变量
      selectedIndex: 0, // 指示器索引
      total: 0,  // 指示器索引
      title: "", //标题
      content: "", //内容
      creator: {}, //用户数据
      inviteIf: "", //是否有邀约信息
      inviteInfo: {}, //邀约信息
      location: {}, //IP地址
      createTime: "", //发布时间
      publishTime: "",//发布时间
      images: [], //轮播
      getList: {
        postId: null, //帖子id
        pageNum: "1",
        pageSize: "2",
      },
      labels: [], // 标签
      creatorLabels: [], //用户标签
      cut: 1, //切换评论&精彩瞬间
      commentList: [], // 评论列表数据
      levelcommentList: [], //层级评论列表数据
      momentList: [], // 精彩瞬间列表数据
      allPayedIf: [], // 费用全包和魅力值
      avatarslist: [], //邀约参与人头像
      likes: "", //点赞数
      favorites: '', //收藏数量
      comments: "", //评论数
      man: 0,
      woman: 0,
      sum: 0,
      swipeIndex: 1,
      current: 1, // 指示器索引值
      oldCurrent: 0, // 上一步索引值
      first: false,
      last: true,
      moveLeft: false,
      moveRight: false,
      inviteBeginEndDate: '',
      inviteLocation: '',
      href: "",
      startX: 0 //记录滑动开始的位置
    }
  },
  created() {
    this.href = `ssm://sonitalk?params=${this.$route.query.postId}&type=${this.$route.query.type}`
    console.log(this.href, 'href')
    //获取路由携带的参数
    this.getList.postId = this.$route.query.postId
  },

  computed: {
    progress() {
      return (this.man / this.sum) * 100;
    }
  },
  async mounted() {
    this.params = getURLParameters()
    console.log(this.params, 'pppp222')
    await this.getLists()
    this.clipCanvas(this.creator.avatar, 'myCanvas')
    this.MomentByPostId()
    this.getallPayedIf()
    // 获取包含行内元素的父元素 如果标签换行 并获取换行的标签并移除
    var parentElement = document.querySelector(".title_box");
    if (parentElement) {
      // 获取所有的行内元素
      var elements = parentElement.querySelectorAll("span");
      const otherElements = []
      // 遍历行内元素
      for (var i = 1; i < elements.length; i++) {
        if (elements[i].offsetTop !== elements[i - 1].offsetTop) {
          otherElements.push(elements[i])
        }
      }
      otherElements.forEach(element => {
        element.style.display = 'none'
      })
    }

  },

  methods: {
    // 安卓打开app
    unInstall() {
      webClick({click: 'ssm_web_h5_download_click', channel: this.params.channel, appType: 'Android'})
      const _this = this
      //在iframe 中打开APP
      var ifr = document.createElement('iframe');
      ifr.src = this.href;
      ifr.style.display = 'none';

      document.body.appendChild(ifr);
      setTimeout(function () {
        document.body.removeChild(ifr);
      }, 500);
      var now = Date.now();
      setTimeout(function () {
        if (Date.now() - now < 3000) {
          // App未成功唤醒，跳转到下载页
          _this.$router.push('/androidApp')
        }
      }, 1500);
    },
    //
    openImg(url) {
      // ImagePreview([url]);
    },
    // 指示器滚动
    handleScrollDotView() {
      setTimeout(() => {
        const selected = document.querySelector('.selectedDot');
        const selectedLeft = selected.getBoundingClientRect().x;
        // 将选中的点偏移至中间
        const scrollDom = document.querySelector('.dotWrapper');
        const offset = selectedLeft - (window.innerWidth - 8) / 2;
        const duration = 1000;
        const frames = Math.round(duration / 1000 * 16);
        let frame = 0; // 过渡帧数

        const animate = () => {
          scrollDom.scrollLeft += offset / frames;
          if (++frame < frames) {
            window.requestAnimationFrame(animate);
          }
        };
        window.requestAnimationFrame(animate);
      }, 100);
    },
    //计算男女占比 50%
    percentage(data1) {
      if (this.sum == 0) {
        return 0 + "%"
      } else {
        return Math.round((data1 / this.sum) * 100) + "%";

      }
    },
    onChange(index) {
      this.swipeIndex = index + 1
      let newIndex = index + 1 // 当前索引值
      this.record = newIndex
      if (newIndex > this.oldCurrent) {
        // 递增
        if (newIndex >= this.images.length - 1) {
          if (newIndex == this.images.length) {
            this.current = this.images.length
            this.last = false
            this.first = true
            return
          }
          this.current = this.images.length - 1
          this.first = true
          if (!this.last) {

          } else {
            this.moveLeft = true
            setTimeout(() => {
              this.moveLeft = false
              this.last = false
            }, 250)
          }
        } else {
          if (this.current >= this.images.length - 1) {
            this.current = this.images.length - 1
            this.first = true
            this.moveLeft = true
            setTimeout(() => {
              this.moveLeft = false
            }, 250)
          } else {
            this.current++
          }
          if (!this.last) {

          } else {
            this.last = true
          }
        }
      } else {
        // 递减
        if ((this.images.length - newIndex) >= this.images.length - 1) {
          this.last = true
        }
        if (newIndex == 1) {
          this.current = 1
          this.last = true
          this.first = false
        } else {
          if (this.current <= 2) {
            if (newIndex <= 2) {
              this.first = false
            }
            this.current = 2
            this.moveRight = true
            setTimeout(() => {
              this.moveRight = false
            }, 250)
          } else {
            this.current--
            if (!this.first) {

            } else {
              this.first = true
            }
          }
        }
      }
      // 记录上一步索引值
      this.oldCurrent = newIndex
      // if (this.swipeIndex > 3 && this.swipeIndex < 6) {
      // document.querySelectorAll('.dot')[1].style.transform ='scale(0.7)'
      // document.querySelectorAll('.dot')[5].style.transform ='scale(0.7)'
      // }
      // this.handleScrollDotView()
    },
    // 记录初始滑动位置
    onTouchStart(e) {
      e = e || event
      e.preventDefault()
      if (e.touches.length == 1) {
        this.startX = e.touches[0].clientX
      }
    },
    // 记录每次滑动位置
    onTouchMove(e) {
      e = e || event
      e.preventDefault()
      let surrentStartX
      if (e.touches.length == 1) {
        surrentStartX = e.touches[0].clientX
      }
      if (surrentStartX < this.startX) {
        // console.log('我是右滑')
        // 右滑
        // this.touchAble = true
        // this.$refs.swiper.resize()
      } else {
        // console.log('我是左滑')
        // 左滑
        // this.touchAble = false
        // this.$refs.swiper.resize()
      }
    },
    onTouchEnd(position) {

    },
    // 切割头像
    clipCanvas(src, id) {
      clip(500, 500, 50, 50, 50, 50, src, id)
    },
    // 加载帖子详情
    async getLists() {
      try {
        const res = await getList(this.getList)
        if (res.code === 200) {
          this.title = res.data.title
          this.labels = res.data.labels.map(label => `#${label}`)
          this.content = res.data.content
          this.creator = res.data.creator
          this.inviteIf = res.data.inviteIf
          this.inviteInfo = res.data.inviteInfo
          this.inviteBeginEndDate = res.data.inviteInfo ? res.data.inviteInfo.inviteBeginEndDate : ''
          this.inviteLocation = res.data.inviteInfo ? res.data.inviteInfo.inviteLocation : ""
          // if (this.inviteInfo && this.inviteInfo.beginDate) {
          //   this.inviteInfo.beginDate = dayjs(res.data.inviteInfo.beginDate).format("YYYY.MM.DD")
          //   this.inviteInfo.endDate = dayjs(res.data.inviteInfo.endDate).format("YYYY.MM.DD")
          // }
          // // 判断出发地目的地
          // if (res.data.inviteInfo) {
          //   if (res.data.inviteInfo && res.data.inviteInfo.toLocation) {
          //     this.toCity = res.data.inviteInfo.toCity + ' · ' + res.data.inviteInfo.toLocation.point
          //   } else {
          //     if (res.data.inviteInfo.toProvince && res.data.inviteInfo.toCity) {
          //       this.toCity = res.data.inviteInfo.toProvince + ' · ' + res.data.inviteInfo.toCity
          //     }
          //     if (!res.data.inviteInfo.toCity) {
          //       this.toCity = res.data.inviteInfo.toProvince
          //     }
          //     if (!res.data.inviteInfo.toProvince && res.data.inviteInfo.toCity) {
          //       this.toCity = res.data.inviteInfo.toCity
          //     }
          //   }
          //   this.fromCity =
          //   if (res.data.inviteInfo && res.data.inviteInfo.fromLocation) {
          //     this.fromCity = res.data.inviteInfo.fromCity + ' · ' + res.data.inviteInfo.fromLocation.point
          //   } else {
          //     if (res.data.inviteInfo.fromProvince && res.data.inviteInfo.fromCity) {
          //       this.fromCity = res.data.inviteInfo.fromProvince + ' · ' + res.data.inviteInfo.fromCity
          //     }
          //     if (!res.data.inviteInfo.fromCity) {
          //       this.fromCity = res.data.inviteInfo.toProvince
          //     }
          //     if (!res.data.inviteInfo.fromProvince && res.data.inviteInfo.fromCity) {
          //       this.fromCity = res.data.inviteInfo.fromCity
          //     }
          //   }
          // }
          this.location = res.data.location
          this.createTime = res.data.createTime
          this.publishTime = res.data.publishTime
          this.images = res.data.images
          this.likes = res.data.counter.likesShow
          this.favorites = res.data.counter.favorites || ''
          this.comments = res.data.counter.commentsShow
          this.creatorLabels = res.data.creatorLabels
          console.log(this.creatorLabels,"表亲啊")
          await this.getlevelcommentList()
        }
      } catch (error) {
        console.log(error, 'errorrrrrr')

        if (error == 400) {
          await this.$router.replace("/errorPage")
        } else if (error == 1008) {
          await this.$router.replace("/errorPage")
        } else if (error == 1009) {
          await this.$router.replace("/errorPage")
        } else {
          await this.$router.replace("/errorPage")
        }
      }
    }
    ,
    // 加载精彩瞬间
    async MomentByPostId(data) {
      const res = await MomentByPostId(this.getList)
      this.momentList = res.data.content

      // console.log("精彩瞬间请求结果", res.data.content);
    }
    ,
    //处理@用户的数据
    replaceAtString(str) {
      const pattern = /@\{([^{}]+)\}/g;
      let result = str;
      // 匹配所有形如 @{"userId":12, "nickname":"用户A"} 的字符串并进行替换
      result = result.replace(pattern, (match, info) => {
        let replacement = match;
        try {
          const atInfo = JSON.parse(`{${info}}`);
          if (atInfo && atInfo.nickname) {
            replacement = `<span style="color:#071679 ; margin-left: 2px;">@${atInfo.nickname}</span>`;
          }
        } catch (e) {
        }
        return replacement;
      });

      return result;
    },
    async changeCut(v) {
      // this.getlevelcommentList()
      this.cut = v
      if (v === 2) {
        // 展示自我汇集头像添加回字纹
        if (this.momentList.length) {
          for (const key in this.momentList) {
            this.$nextTick(() => {
              this.clipCanvas(this.momentList[key].creator.avatar, 'avatar' + key)
            })
          }
        }
      }
    },
    //加载层级帖子评论列表
    async getlevelcommentList(data) {
      const res = await getForLevel(this.getList)
      this.levelcommentList = res.data
      console.log(this.levelcommentList, 'this.levelcommentList')
      for (const key in this.levelcommentList) {
        this.$nextTick(() => {
          console.log(this.levelcommentList[key].fromUser.avatar, 'heng')
          this.clipCanvas(this.levelcommentList[key].fromUser.avatar, 'myCanvas' + key)
        })
        this.levelcommentList[key].comment = this.replaceAtString(this.levelcommentList[key].comment)
      }
      // console.log("层级评论请求结果", res.data);
    }
    ,
    // 加载邀约用户数据
    async getallPayedIf(data) {
      const res = await getallPayedIf(this.getList)
      const datas = res.data
      // console.log(datas, "邀约数据")
      //过滤出费用全包的用户信息
      this.allPayedIf = datas.filter(obj => obj.allPayedIf);
      console.log(this.allPayedIf, 'allPayedIfallPayedIfallPayedIf')
      this.avatarslist = datas
      // this.avatarslist = datas.slice(0, 5)
      // console.log(datas,"头像")
      this.sum = this.avatarslist.length
      for (const item of this.avatarslist) {
        if (item.user.gender === "男") {
          this.man++
        } else if (item.user.gender === "女") {
          this.woman++
        }
      }
    },
    // H5调起app逻辑
    showModal() {
      console.log(this.params, 'ppp')
      let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      if (ua.match(/WeiBo/i) == "weibo") {
        this.show = true
        return
      }
      // 检测设备类型并跳转处理
      if (this.isAndroid()) {
        webClick({click: 'ssm_web_h5_download_click', channel: this.params.channel, appType: 'Android'})
        this.openAndroidApp();
      } else if (this.isIOS()) {
        webClick({click: 'ssm_web_h5_download_click', channel: this.params.channel, appType: 'iOS'})
        this.openiOSApp();
      } else {
        // this.redirectToAppStore();
      }
    }
    ,
    isWeibo() {
      let ua = navigator.userAgent.toLowerCase();//获取判断用的对象
      return ua.match(/WeiBo/i) == "weibo";
    },

    isAndroid() {
      return /(android)/i.test(navigator.userAgent);
    }
    ,

    isIOS() {
      return /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
    },
    openAndroidApp() {
      const _this = this
      const packageName = `ssm://sonitalk?params=12345`;
      // const packageName = `ssm://sonitalk?params=${this.getList.postId}`; // 替换为目标App的包名
      window.location.href = packageName;
      setTimeout(function () {
        let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
        if (typeof hidden == "undefined" || hidden == false) {
          _this.$router.push('/androidApp')
        }
      }, 500);
    }
    ,
    openiOSApp() {
      const _this = this
      const scheme = `ssm://post/detail/${this.getList.postId}`; // 替换为目标App的Scheme
      window.location.href = scheme;
      setTimeout(function () {
        let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
        if (typeof hidden == "undefined" || hidden == false) {
          //App store下载地址
          _this.redirectToAppStore()
        }
      }, 500);
    },
    redirectToAppStore() {
      const appStoreLink = 'https://itunes.apple.com/cn/app/id6464382860'; // 替换为目标App的App Store链接
      const playStoreLink = 'https://itunes.apple.com/cn/app/id6464382860'; // 替换为目标App的Play Store链接
      window.location.href = this.isIOS() ? appStoreLink : playStoreLink;
    },
  }
}

</script>

<style lang="less" scoped>
@import "../publicCss/publicCss.less";

/deep/ .van-popup {
  background-color: transparent !important;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  padding-top: 1rem;

  p {
    margin-bottom: 0.3rem;
  }

  .btn {
    border-radius: 0.1rem;
    padding: 0.2rem 0.1rem;
    border: 1px solid #fff;
    width: 2rem;
    margin: 0 auto;

  }
}

@media screen {

  // 自我汇集遮罩
  .selfCut {
    position: absolute;
    z-index: 222;
    width: 100%;
    height: 190px;
    top: 0;
    background-color: transparent;
  }

  .selfCutOpenApp {
    width: 1000px;
    height: 190px;
    display: block;
  }

  // 发布第一条评论遮罩样式
  .noComment {
    position: absolute;
    z-index: 2;
    width: 100%;
  }

  .unWexinOpenApp {
    width: 1000px;
    height: 30px;
    display: block;
  }

  .all {
    width: 100vw;
    height: 100vh;
    //height: fit-content;
    //overflow: auto;
    //height: 100vh;
    /*background-color: green;*/
    //font-size: 16px;
    box-sizing: border-box;
    overflow-x: hidden;
    position: relative;
    padding-bottom: 80px;
    color: #191919;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    //background-color: #fff;
  }

  .box {
    position: fixed;
    box-sizing: border-box;
    width: 100vw;
    padding: 12px 0 12px 0;
    height: 56px;
    //line-height: 56px;
    background: #FFFFFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;
    opacity: 1;
  }

  .box-left {
    display: flex;
    //align-items: center;
    //line-height: 30px;
    //vertical-align: middle;
    ////width: 146px;
    //height: 30px;
    justify-content: center;
  }

  .img {
    width: 24px;
    height: 24px;
    border-radius: 7px 7px 7px 7px;
    background: #D9D9D9;
    margin: 12px 0 12px 13px;
    vertical-align: middle;
    line-height: 30px;
  }

  .img_div {
    vertical-align: middle;
    line-height: 30px;
  }

  .box-left-right {
    margin-left: 10px;
    font-size: 13px;
    font-weight: 400;
    color: #191919;
    width: 52px;
    height: 13.7px;
    line-height: 13.7px;
  }

  .box-left-right-bottom {
    width: 140px;
    height: 14px;
    line-height: 14px;
    font-size: 12px;
    margin-left: 10px;
    color: #AAAAAA;
  }

  .vant-margin-wrap {
    //height: 500px;
    margin-top: 56px;
    height: auto;
    max-height: 500px;
    //width: 100%;
    //line-height: 1;
    //height: 100%;
    //height: 467px;
    //max-height: 500px;
    //height: auto;
    //position: relative;
    //display: grid;
    //place-items: center;
    background-color: #F5F6F9;
    display: flex;

  }

  .swiper {
    position: relative;
    height: auto;
    //max-height: 500px;
  }

  .swiper-pagination-fraction,
  .swiper-pagination-custom,
  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 10px !important;
    height: 10px !important;
  }

  /deep/ .swiper-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
    background: #384594 !important;
  }

  ///deep/ .van-swipe__track
  //{
  //  display: flex;
  //}
  .van-swipe {
    width: 100%;
    max-height: 500px;
    //display: flex;
    //justify-content: center; /* 水平居中 */
    //align-items: center; /* 垂直居中 */
    //height: auto;
  }

  .images {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 自定义指示器样式
  .dots {
    width: 100%;
    height: auto;
    display: flex;
    padding: 0 10px;
    justify-content: center;
    flex-wrap: nowrap;
    position: absolute;
    //bottom: 9px;
    //bottom: 20px;
    z-index: 9999999;
    //background-color: red;

    .navItem {
      margin-right: 6px;
      background-color: rgba(255, 255, 255, 0.6);
    }

    .active {
      background-color: #FFFFFF;
    }

    .mini {
      //transform: scale(0.6);
    }
  }

  .dotWrapper {
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    white-space: nowrap;
    text-align: center;
  }

  .dotWrapper_div {
    width: 14.3px;
    height: 2px;
    border-radius: 6px;
  }

  .dotWrapper_div1 {
    width: 20px;
    height: 2px;
    border-radius: 6px;
  }

  .dotWrapper_div2 {
    width: 28px;
    height: 2px;
    border-radius: 6px;
  }

  .dot {
    position: relative;
    //top: -8px;
    bottom: 20px;
    display: inline-block;

    background-color: rgba(0, 0, 0, 0.1);
    margin-right: 8px;
    transform: scale(1);
    transition: all .2s ease;

  }

  .dot:last-child {
    margin-right: 0;
  }

  .selectedDot {
    background-color: #FFFFFF;
  }

  .smallDot {
    transform: scale(0.6);
  }

  .swipe-num {
    width: 25px;
    height: 20px;
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 10px 10px 10px 10px;
    //opacity: 0.1;
    font-size: 9px;
    color: #384594;
    text-align: center;
    line-height: 22px;
    //padding: 5px 7px;
    z-index: 999;
  }

  .swiper-box {
    position: relative;
  }

  .custom-indicator {
    position: absolute;
    right: 5px;
    top: 66px;
    padding: 2px 5px;
    font-size: 12px;
    color: #FFFFFF;
    background: rgba(0, 0, 0, 0.1);
  }

  .browser-open-app {
    display: block;
    width: 76px;
    height: 28px;
    font-size: 14px;
    //line-height: 25px;
    text-align: center;
    // background: @public-color;
    // border-radius: 50px 50px 50px 50px;

    // background-size: cover;
    font-weight: 400;
    // padding: 5px 8px 5px 8px;
    // margin-right: 13px;
    color: #FFFFFF;
    margin-right: 15px;
    line-height: 0.74667rem;
    background: url(../assets/btn_bg.svg) no-repeat;
    background-size: 100% 100%;

  }

  .zszw {
    width: 100%;
    height: 32px;
    margin: 20px 0 0 0;
  }

  .zszw-content {
    width: 347px;
    height: 32px;
    background: rgba(7, 22, 121, 0.1);
    border-radius: 4px 4px 4px 4px;
    margin-left: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .zszw-content-left {
    height: 32px;
    width: 80px;
    line-height: 32px;
    text-align: center;
    margin-left: 9px;
  }

  .zszw-content-left img {
    vertical-align: middle;
    display: inline-block;
  }

  .zszw-content-left span {
    vertical-align: middle;
    margin-left: 7px;
    color: @public-color;
    font-size: 12px;

  }

  .post {
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    //margin-top: -10px;
  }

  .tops {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //margin-left: 14px;
    padding-left: 14px;
    position: relative;

  }

  .head {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
  }

  .head-lable {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 32px;
    padding-left: 6px;

    .befautiful {
      font-size: 14px;
      font-weight: 500;
      color: #191919;
    }
  }

  .head-img {
    width:33px;height: 35px;
    // width: 32px;
    // height: 32px;
    position: relative;
    opacity: 1;
    // border: 1px solid #EEEEEE;
    vertical-align: middle;
    // margin-top: 0.14rem;
    background: url(../assets/hpbg.png) no-repeat;
    background-size: cover;
  }
  .myCanvas{
    position: absolute;
    width: 30px;
    height: 30px;
    margin: auto;
    inset: 0px;
    top:2px;
    left: 1px;
    z-index: -1;
  }

  .nickname {
    width: auto;
    height: 28px;
    font-size: 14px;
    font-weight: 700;
    color: #191919;
    //line-height: 28px;
    //margin-left: 6px;
    vertical-align: middle;
  }

  .title_box {
    // overflow: hidden;
    // height:30px;
    // display: flex;
    // align-items: center;
    // justify-content: space-around;
  }

  .nicknames {
    display: inline-block;
    width: 110px;
    font-size: 11px;
    //height: 28px;
    //font-weight: 700;
    color: #666666;
    //line-height: 28px;
    //margin-left: 6px;
    vertical-align: middle;
    white-space: nowrap;


  }

  .nickName {
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    color: #191919;
    margin-right: 8px;
    padding-left: 5px;
  }

  .label {
    //display: inline-block;
    //box-sizing: border-box;
    //text-align: center;
    //padding: 0px 8px;
    //line-height: 0.50667rem;
    //height: 18px;
    width: auto;
    //line-height: 20px;
    padding: 3px 6px 3px 6px;
    font-size: 11.4px;
    text-align: center;
    font-weight: 400;
    margin-right: 5px;
    margin-top: 2px;
    color: #845400;
    background: url(../assets/yellow_bg.png) no-repeat;
    background-size: 100% 100%;
    background-position: center;
  }

  .guanzhu {
    width: 57px;
    height: 24px;
    font-size: 14px;
    color: @public-color;
    margin-right: 12px;
    font-weight: 500;
    display: block;
    line-height: 26px;
    //line-height: 30px;
    text-align: center;
    margin-top: 10px;
    background: url(../assets/guanzhu-bg.svg) no-repeat;
    background-size: 100% 100%;
  }

  #app {
    text-align: left;
  }

  .tit {
    box-sizing: border-box;
    width: auto;
    height: 19px;
    opacity: 1;
    margin: 10px 14px 8px 14px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 19px;

  }

  .placetime {
    box-sizing: border-box;
    width: 100vw;
    // height: 42px;
    margin-left: 14px;
    display: flex;
    flex-direction: column;

    // padding-top: 4px;
    img {
      width: 16px;
      height: 16px;
    }
  }

  .places {
    width: 98%;
    //height: 16px;
    // font-size: 12px;
    font-weight: 500;
    //color: #666666;
    //line-height: 16px;
    display: inline-block;
    /* 将容器设置为内联块级元素 */
    vertical-align: middle;
    /* 垂直居中对齐 */
    margin-bottom: 4px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #845400;

    span {
      font-size: 14px;
    }
  }


  .time {
    width: auto;
    //height: 16px;
    // font-size: 12px;
    font-weight: 400;
    color: #845400;
    // color: @public-hs;
    //line-height: 16px;
    // display: inline-block;
    /* 将容器设置为内联块级元素 */
    vertical-align: middle;
    line-height: 16px;

    span {
      font-size: 12px;
    }

    /* 垂直居中对齐 */
  }

  .all-in {
    padding: 0;
    margin: 0;
    width: 266px;
    // height: 248px;
    //background: rgba(7, 22, 121, 0.1);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 10px auto;
    text-align: center;
    box-sizing: border-box;
    //display: flex;
    //flex-direction: column;
    //justify-content: space-evenly;
    //align-items: center;
    //position: relative;

  }

  .all-in-rqz {
    width: 89.13px;
    height: 27.72px;
    background-image: url('../assets/bgi.svg');
    /* 设置背景图片的路径 */
    background-size: cover;
    /* 背景图片自适应 div 大小并保持比例 */
    background-position: center;
    /* 将背景图片水平垂直居中 */
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    // line-height: 27.72px;
    line-height: 0.7392rem;
    color: #000000FF;
  }

  .all-in-avater {
    width: 103px;
    height: 108px;
    box-sizing: border-box;
    //background-image: url('../assets/Vector.svg'); /* 设置背景图片的路径 */
    //background-position: center; /* 将背景图片水平垂直居中 */
    //background-size: contain; /* 图片尺寸适应 div 的大小，不拉伸也不失真 */
    //background-repeat: no-repeat; /* 不允许背景图片重复 */
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: -1;
    position: relative;
    margin-top: -9px;
  }

  .imgOne {
    width: 103px;
    // height: 108px;
  }

  .imgTwo {
    width: 103px;
    height: 108px;
  }

  .all-in-avater-img {
    position: absolute;
  }

  .all-in-shade {
    width: 347px;
    height: 59px;
    background: rgba(7, 22, 121, 0.1);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    z-index: 100;
    transform: translate(-50%, 0);
    opacity: .1;
  }

  .all-in-first {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    padding-top: 5px;
  }

  .all-in-last {
    height: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 24px;
    margin-bottom: 5px;
  }

  .all-in-head {
    display: inline-block;
    vertical-align: middle;
    margin-left: 7px;
  }

  .all-in-head-img {
    width: 16px;
    height: 16px;
    opacity: 1;
    border: 1px solid #EEEEEE;
    vertical-align: middle;
    margin-bottom: 2px;
    margin-left: 4px;
  }

  .wxopenApp {
    width: 140px;
    height: 35px;
    background: #4DC6C9;
    //background: red;
    border-radius: 40px 40px 40px 40px;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 35px;
    text-align: center;
    position: fixed;
    bottom: 11%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }

  .openApp {
    display: block;
    width: 133px;
    height: 40px;
    background: url(../assets/nav_bg.svg) no-repeat;
    background-size: 100% 100%;
    line-height: 1.06667rem;
    // background: #384594;
    // border-radius: 40px 40px 40px 40px;
    font-size: 14px;
    color: #FFFFFF;
    //line-height: 35px;
    // padding: 10px 0;
    text-align: center;
    position: fixed;
    bottom: 11%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }

  .heat {
    display: flex;
    align-items: center;
    font-size: 9px;
    font-weight: 400;
    color: #FFFFFF;
    width: auto;
    height: 16px;
    line-height: 16px;
    background: linear-gradient(0deg, #EF7878 0%, #FFC2C2 100%);
    border-radius: 20px 20px 20px 20px;
    padding: 1px 4px 1px 1px;
  }

  .all-in-label {
    box-sizing: border-box;
    height: 14px;
    padding: 0 4px;
    border-radius: 10px 10px 10px 10px;
    opacity: 0.5;
    border: 1px solid @public-color;
    font-size: 9px;
    line-height: 14px;
    font-weight: 400;
    color: @public-color;
    text-align: center;
    margin-right: 4px;
    font-family: PingFang SC, PingFang SC;
  }

  .right-jt {
    position: absolute;
    top: 19px;
    right: 1px;
    transform: translate(-50%, -50%);
  }

  .invite {
    width: 357px;
    height: 128px;
    background-image: url(../assets/inbite-bg.png);
    background-size: 100% 100%;
    //background-color: rgba(0, 0, 0, 0.02);
    border-radius: 8px 8px 8px 8px;
    margin: 16px auto;
    position: relative;
    z-index: 1;
  }

  .invite-top {
    box-sizing: border-box;
    width: 100%;
    height: 59px;
    // display: flex;
    // justify-content: space-evenly;
    // align-items: center;
    font-size: 12px;
    font-weight: 700;
    //border-bottom: 1px solid #EEEEEE;
    // padding-top: 10px;
    // padding-bottom: 9px;
    position: relative;
    //background-color: red;
    display: flex;
    justify-content: center;
    align-items: center;

    > div {
      text-align: center;
      //padding-left: 8px;
      //position: absolute;
      //margin: auto;
      //left: 0;
      //right: 0;
      //bottom: 0;
      //top: 0;
      //height: 35px;
    }
  }

  .top1 {
    width: 116px;
    height: 70px;
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
  }

  .top1 > div {
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 14px;
    margin-bottom: 4px;
  }

  .top1 > span {
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #191919;
    line-height: 19px;
    margin-bottom: 13px;
  }

  .invite-bottom {
    width: 100%;
    height: calc(100% - 70px);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    position: relative;
  }

  .imgview {
    box-sizing: border-box;
    // width: 120px;
    // border: 1px solid black;
    min-width: 120px;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;
    justify-content: center;
    position: relative;
    margin-left: 8px;
    margin-top: 35px;
  }

  .circle-img {
    position: absolute;
    left: 3.7rem;
    height: 18px;
    width: 18px;
    bottom: 3px;
    margin-left: 2px;
  }

  .imgview img {
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    // border: 1px solid #EEEEEE;
  }

  .tou {
    box-sizing: border-box;
    // width: 20px;
    // height: 20px;
    // border-radius: 50%;
    opacity: 1;
    // border: 1px solid #EEEEEE;
    margin: 1px 1px;
  }

  .tou ::v-deep(.van-image__img) {
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  .jindu {
    width: 174px;
    //height: calc( - 70px);
    height: 28.5px;
    //margin-right: 25px;
    margin-bottom: 8px;
    margin-left: 31px;
    //margin-right: 16px;
    background-image: url(../assets/jindu-bg.png);
    background-size: 100% 100%;
    margin-top: 40px;
  }

  .nv {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .player {
    width: 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 100px;
  }

  .progress-bar {
    position: relative;
    width: 52px;
    height: 2px;
    border-radius: 5px;
    //overflow: hidden;
    margin-top: 2px;
    margin-left: 30px;
  }

  .progress {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 5px;
  }

  .bfb {
    font-size: 9px;
    color: #FFFFFF;
    width: 31px;
    height: 12.5px;
    text-align: center;
    line-height: 12.5px;
    border-radius: 10px;
  }

  .canyu {
    margin-left: 14px;
    width: 80px;
    height: 100%;
    font-size: 12px;
    display: flex;
    /*justify-content: flex-end;*/
    align-items: center;
    color: @public-color;
    // margin-right: 10px;
    position: absolute;
    right: 0;
    top: 0;

    /* background-color: bisque; */

    .party {
      width: 64px;
      height: 24px;
      line-height: 0.58rem;
      color: #fff !important;
      background: url(../assets/party_bg.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -15px;
      right: 0;
      // padding-left: 11px;
      text-align: center;

      .people {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        display: inline-block;
        margin-right: 2px;
      }

      span {
        display: inline-block;
        vertical-align: middle;
      }

      // &::before {
      //   position: absolute;
      //   content: '';
      //   display: inline-block;
      //   width: 16px;
      //   height: 16px;
      //   background: url(../assets/invite_select.svg) no-repeat;
      //   left: 11px;
      //   top: 0.12rem;
      // }
    }

    .full {
      width: 64px;
      height: 24px;
      line-height: 0.64rem;
      color: #ccc !important;
      background: url(../assets/no_btn_bg.png) no-repeat;
      background-size: contain;
      position: relative;
      padding-left: 30px;
      margin-bottom: 55px;
      font-size: 11px;
      position: absolute;
      top: -15px;
      right: 0;

      //&::before {
      //  position: absolute;
      //  content: '';
      //  display: inline-block;
      //  width: 16px;
      //  height: 16px;
      //  background: url(../assets/no_invite_select.svg) no-repeat;
      //  left: 8px;
      //  top: 0.12rem;
      //}
    }
  }


  .toapp {
    width: 200px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    border-radius: 50px;
    position: fixed;
    bottom: 25vh;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 999;
  }

  .userHead {
    width: 100%;
    height: 250px;
    margin-top: 20px;
    text-align: center;
  }

  .userHead img {
    width: 200px;
    height: 200px;
    border-radius: 50%;
  }

  .content {
    width: 100%;
    height: auto;
    padding: 0 14px;
  }

  .content-top {
    width: 100%;
    height: auto;
    font-size: 14px;
    display: -webkit-box;
    margin: 0 auto;
    line-height: 20px;
    /* 基于 WebKit 的浏览器的旧版本 */
    //-webkit-line-clamp: 3;
    /* 行数限制 */
    //-webkit-box-orient: vertical;
    /* 垂直排列 */
    //overflow: hidden;
    /* 超出隐藏 */
    //text-overflow: ellipsis;
    /* 显示省略号 */
  }

  .labelList {
    margin-top: 3px;
    width: auto;
    height: auto;
    line-height: 17px;
    //margin-top: 4px;
    //display: flex;
    //align-items: center;
    //justify-content: left;
    //word-break: break-all;
  }

  .labels {
    width: auto;
    //height: 18px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    //line-height: 15px;
    margin-right: 8px;


  }

  .content-bottom {
    width: 100%;
    height: 40px;
    font-size: 10px;
    //line-height: 40px;
    border-bottom: 1px solid #EEEEEE;
    display: inline-block;
    /* 将容器设置为内联块级元素 */
    vertical-align: middle;
    /* 垂直居中对齐 */
    color: @public-hs;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;


    img {
      width: 16px;
      height: 16px;
    }
  }

  // 轮播图指示器按钮颜色
  /deep/ .van-swipe__indicator--active {
    background-color: #384594 !important;
  }

  .content-bottom-span {
    //margin-left: 5px;
    line-height: 40px;
  }

  .buttom {
    width: 100%;
    height: auto;
    margin-top: 30px;
    // padding-bottom: 70px;
    // min-height: 126px;
  }

  .first {
    width: 100%;
    // height: 15px;
    padding-top: 0.65rem;
    // line-height: 13px;
    text-align: center;

    font-size: 14px;
    color: @public-color;
  }

  .no-hj {
    width: 100%;
    // height: 15px;
    // line-height: 13px;
    text-align: center;
    padding-top: 0.65rem;
    font-size: 14px;
    color: @public-hs;
    display: block;

  }

  .buttom-top {
    width: 100%;
    height: 25px;
    font-size: 14px;
    //margin-left: 14px;
    margin-bottom: 10px;
    font-weight: 400;
    color: #666666;
  }


  .noData {
    height: 132px;
    //background-color: red;
  }

  .pl {
    position: relative;
    display: inline-block;
    height: 15px;
    color: #666;
    margin-left: 20px;

    .pl-img {
      position: absolute;
      //left: 10px;
      //left: -5px;
      bottom: -10px;
      //width: 93%;
      // height: 15px;
    }
  }

  .self {
    position: relative;
    display: inline-block;
    height: 15px;
    color: #666;
    margin-left: 5px;

    .self-img {
      position: absolute;
      //left: 10px;
      //left: -5px;
      bottom: -22px;
      //width: 93%;
      // height: 15px;
    }
  }

  .buttom-top span {
    margin-right: 30px;
  }

  .zw {
    //width: 46.5px;
    height: 22px;
    margin-left: -10px;
    margin-bottom: 5px;
    //position: absolute;
    //background-color: red;
  }

  .comment {
    width: 100%;
    height: auto;
    //border-top: 0.5px solid #EEEEEE;
    padding-top: 10px;

  }

  .comment-2 {
    // width: 100%;
    width: 93%;
    margin: 0 auto;
    height: auto;
    padding-top: 10px;
    border-bottom: 1px solid #EEEEEE;
    position: relative;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(134deg, #FFFFFF 0%, rgba(255, 255, 255, 0.95) 100%);
    z-index: 1;
  }

  .overlay-div {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 13px;
    font-weight: 500;
    color: #191919;
    // color: @public-hs;
  }

  .new-comment-top {
    border: none !important;
  }

  .comment-top {
    width: 93%;
    margin: 0 auto;
    border-bottom: 1px solid #EEEEEE;
    height: auto;
    display: flex;
    justify-content: space-between;
    position: relative;

    .navgiteApp {
      position: absolute;
      width: 50px;
      right: 0;
    }

  }

  .comment-top-left {
    //display: inline-block;
    //vertical-align: middle;
    width: calc(100% - 40px);
    display: flex;
    height: auto;
  }

  .comment-canvas {
    background: url(../assets/hpbg.png) no-repeat;
    background-size: cover;
    position: relative;
    margin-left: 0px;
    width:33px;
    height:35px
  }
  .canvas-class{
    position: absolute;
    width: 30px;
    height: 30px;
    margin: auto;
    inset: 0px;
    top:2px;
    left: 1px;
    z-index: -1;
  }
  .canvas-class-div {
    width:40px;
    height:40px;
  }

  .comment-top-left-2 {
    // vertical-align: middle;
    // display: flex;
    // margin-left: 14px;
    // border: 1px solid black;
  }

  .comment-top-left-2 img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    opacity: 1;
    vertical-align: middle;
    // border: 1px solid #EEEEEE;
  }

  .comment-top-left-img {
    width: 32px;
    height: 32px;
    // margin-top: 2px;
    vertical-align: middle;
    border-radius: 50%;
    margin-left: 14px;
    border: 1px solid #EEEEEE;
  }

  .comment-top-left-2 span {
    width: auto;
    // height: 32px;
    // line-height: 32px;
    margin-left: 4px;
    font-size: 12px;
    color: @public-hs;
    display: inline-block;
    vertical-align: middle;
  }

  .comment-buttom-div {
    margin: 8px 0 8px 0px;
    font-size: 14px;
    width: 340px;
    word-break: break-all;
    line-height: 1.3;
    color: #191919;
  }

  .gd {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 14px;
    color: @public-color;
    display: block;
  }

  .comment-top-right {
    display: flex;
    flex-direction: column;
    //justify-content: center;
    align-items: center;
    margin-right: -4px;
    width: 40px;
    color: #666666;
  }

  .comment-top-right img {
    width: 20px;
  }

  .comment-top-right div {
    font-size: 10px;
    color: #666666;
    font-weight: 400;
  }

  .comment-buttom {
    height: auto;
    font-size: 12px;
    /* display: flex; */
    margin-bottom: 5px;
    // border-bottom: 1px solid #EEEEEE;
    padding-bottom: 12px;
  }

  .new-comment-buttom {
    border: none !important;
  }

  .new-comment-2 {
    border: none !important;
  }


  .comment-buttom-2 {
    width: 100%;
    height: auto;
    position: relative;
    //background-color: red;
  }

  .img-num {
    position: absolute;
    right: 26px;
    bottom: 25px;
    font-size: 13px;
    font-weight: 500;
    color: #FFFFFF;
    //color: black;
  }

  .comment-buttom-imgs-2-3 {
    display: flex;
    // padding-left: 14px;
  }

  .comment-buttom-imgs-2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    // padding: 0 15px 0 15px;
  }

  .kejian {
    width: 106px;
    height: 106px;
  }

  .image-item {
    position: relative;
    //flex: 1;
    margin-right: 17px;
    /* 添加右边距 */
  }

  .picture {
    width: 106px;
    height: 106px;
  }

  .image-item:last-child {
    margin-right: 0;
    /* 最后一张图去掉右边距 */
  }

  .image-item-img {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }


  //.comment-buttom-imgs-2-1 {
  //  display: flex;
  //  ////justify-content: space-evenly;
  //  //align-items: center;
  //  margin-right: 15px; /* 添加右边距 */
  //}
  //.comment-buttom-imgs-2-2 {
  //  display: flex;
  //  ////justify-content: space-evenly;
  //  //align-items: center;
  //  margin-right: 15px; /* 添加右边距 */
  //
  //}
  .hj {
    // width: 100%;
    // height: 50px;
    // line-height: 50px;
    text-align: center;
    font-size: 14px;
    color: @public-color;
    display: block;

  }

  .nick {
    font-weight: 400;
    color: @public-hs;
    font-size: 12px;
    margin-left: 4px;
    margin-right: 8px;
  }

  .pl-div {
    margin-left: 4px;
    margin-top: 2px;
    display: flex;
    flex-wrap: wrap;
    width: 90vw;
    margin-bottom: 2px;
    font-size: 14px;
    line-height: 1.3;
    /* 设置要显示的宽度 */
    //height: 15px;
    //line-height: 15px;
  }

  .pl-div-span {
    //white-space: normal; /* 不允许换行 */
    //overflow: hidden; /* 超出部分隐藏 */
    //text-overflow: ellipsis; /* 显示省略号 */
    margin-right: 10px;
    /* 添加右边距 */
    font-size: 11px;
    color: #AAAAAA;
    height: 15px;
    line-height: 18px;
    margin-left: 4px;
  }

  .zz {
    min-width: 26px;
     height: 15px;
    text-align: center;
    display: inline-block;
    background: url(../assets/zz.svg) no-repeat;
    background-size: contain;
    // background: rgba(189, 147, 35, 0.2);
    // border-radius: 10px 10px 10px 10px;
    // padding: 2px 5px 2px 4px;
    color: #845400;
    // margin-left: 4px;
    font-size: 9px;
    line-height: 15px;
    //position: absolute;
    //position: absolute;

  }


  .comment-buttom-span {
    width: 280px;
    height: auto;
    margin-top: 4px;

  }

  .hf {
    margin-left: 5px;
    width: 30px;
    height: 14px;
    font-weight: 400;
    color: #666666;
    margin-top: 4px;
    text-align: center;
    font-size: 11px;
    line-height: 14px;
  }

  .comment-buttom-imgs {
    width: 100%;
    height: 110px;
    /* background-color: pink; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 6%;
  }

  .comment-buttom-imgs img {
    width: calc(100% / 4);
    height: 120px;
  }

  .comment-buttom-time {
    color: gainsboro;
    margin-top: 6px;
    // margin-left: 14px;
    margin-bottom: 2px;
    font-size: 12px;
  }

  .chakan {
    width: 100%;
    height: 200px;
    /* background-color: pink; */
    margin-top: 20px;
    font-size: 12px;
    text-align: center;
    line-height: 50px;
  }

  .search {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #fff;
    //background-color: red;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    // border-top: 1px solid #EEEEEE;
    box-shadow: 2px 2px 5px #EEEEEE;
    z-index: 11;
    transform: translate(0, 0)
  }


  .dianzan {
    width: calc(100% / 3);
    height: 60px;
    font-size: 12px;
    line-height: 40px;
    text-align: center;
    vertical-align: middle;
    // margin-top: 19px;
  }

  .dianzan img {
    width: 24px;
    vertical-align: middle;
  }

  .dianzan span {
    font-weight: 400;
    color: #384594;
    font-size: 14px;
    vertical-align: middle;
  }

  .dark {
    font-weight: 600;
    color: #191919;
    // border-bottom: 1px solid #191919;
    padding-bottom: 2px;
  }
}

.nicknameShow {
  font-size: 14px;
  color: #191919;
  margin-bottom: 8px;
  font-weight: 500;
  margin-top: 2px;
}

/*//@bg:red;*/
</style>

<style>
.van-image-preview__index {
  display: none;
}

@keyframes moveLeft {
  100% {
    transform: translateX(-30 rpx);
  }
}

@keyframes moveLeftTiny {
  100% {
    transform: translateX(-30 rpx) scale(0.6);
  }
}

@keyframes moveLeftOne {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

@keyframes moveRight {
  100% {
    transform: translateX(30 rpx);
  }
}

@keyframes moveRightTiny {
  100% {
    transform: translateX(30 rpx) scale(0.6);
  }
}

@keyframes moveRightOne {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}
</style>
